
import React, { useEffect, useState } from "react";
import { candidatesAPI, headcountAPI, offerLetterAPI, offersAPI, offerMasterAPI, jobsAPI, workflowMasterAPI } from "../api/client.js";
import { TableSkeleton } from "../components/LoadingSkeleton";
import { toast } from "react-toastify";
import { hasRole } from "../utils/accessControl";
import { mayPerform } from "../utils/userAccess";
import "./Offers.css";
import LoadingButton from "../components/LoadingButton";
import { useNavigate } from "react-router-dom";

import RecruiterOfferEditor from "./Editpermission/RecruiterOfferEditor";
import HiringManagerOfferEditor from "./Editpermission/HiringManagerOfferEditor";
import BUHeadOfferEditor from "./Editpermission/BUHeadOfferEditor";
import HROfferEditor from "./Editpermission/HROfferEditor";

import { EDITABLE_FIELDS } from "./Editpermission/EDITABLE_FIELDS"

import {
  getOfferDateErrors,
  retentionInstallmentMin,
  todayISODate,
} from "../utils/offerDateRules";

import {
  computeOfferCtcTotals,
  getOfferCompensationSummary,
  formatInr,
} from "../utils/offerSalary";

import DelegateModal from "../components/DelegateModal.js";
import ConfirmModal from "../components/ConfirmModal";
import EmptyState from "../components/EmptyState";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { getErrorMessage } from "../utils/errorMessage";

import OfferReleaseChecklistModal from "../pages/checklist/OfferReleaseChecklistModal.jsx";

/**
 * The "Total CTC" cell of the offers list.
 *
 * It shows the headline total of the offer (section E + section F of
 * Annexure-A, i.e. the fixed CTC + the flat medical insurance premium + every
 * variable pay line). When the offer carries variable pay the amount is
 * spelled out underneath so that the variable is never hidden inside a single
 * number.
 */
const renderOfferCtcCell = (offer) => {
  const ctc = getOfferCompensationSummary(offer);

  if (!ctc.hasCompensation) {
    return <span className="offer-ctc-empty">-</span>;
  }

  return (
    <>
      <span className="offer-ctc-total">{formatInr(ctc.total)}</span>

      {ctc.hasVariable && (
        <span className="offer-ctc-variable">
          incl. {formatInr(ctc.variableTotal)} variable
        </span>
      )}
    </>
  );
};






export default function OffersList() {
   
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("workflow");
  

  const [showMailModal, setShowMailModal] = useState(false);
  const [showManageApproverModal, setShowManageApproverModal] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [deletingOffer, setDeletingOffer] = useState(false);

  const [sendingMail, setSendingMail] = useState(false);

  const [selectedOffer, setSelectedOffer] = useState(null);

  const [mailData, setMailData] = useState({
    to: "",
    cc: "",
    subject: "",
    body: "",
    file: null
  });

  const [showCreateOfferModal, setShowCreateOfferModal] = useState(false);
  const [showOfferPreviewModal, setShowOfferPreviewModal] = useState(false);
  const [offerPreviewHtml, setOfferPreviewHtml] = useState("");
  const [generatingPreview, setGeneratingPreview] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [showCandidateSuggestions, setShowCandidateSuggestions] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState(null);

  const [showDelegateModal, setShowDelegateModal] = useState(false);
  const [delegateOffer, setDelegateOffer] = useState(null);
  const [delegateStage, setDelegateStage] = useState(null);

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectingOffer, setRejectingOffer] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const [editingOfferId, setEditingOfferId] = useState(null);
  const [showEditOfferModal, setShowEditOfferModal] = useState(false);
  const [editingOffer, setEditingOffer] = useState(null);

  /* Set while the Create Offer modal is open on a saved draft. A draft is
   * resumed in that same modal rather than the stage editor, and saving it
   * must keep it a draft instead of pushing it into the approval flow. */
  const [editingDraftId, setEditingDraftId] = useState(null);
  const [editOfferStage, setEditOfferStage] = useState(0);
  const [editOfferSaving, setEditOfferSaving] = useState(false);
// ============================================================
  // HR RELEASE CHECKLIST / GENERATED OFFER LETTER
  // ============================================================
  const [showReleaseChecklist, setShowReleaseChecklist] = useState(false);
  const [releaseChecklistOffer, setReleaseChecklistOffer] = useState(null);
  const [hrReleaseOffer, setHrReleaseOffer] = useState(null);
  const [releasingGeneratedOffer, setReleasingGeneratedOffer] = useState(false);
  const [confirmReleaseGenerated, setConfirmReleaseGenerated] = useState(false);

  const isReturnedOffer = (offer) => {
  return (
    String(
      offer?.offer_status || ""
    )
      .trim()
      .toLowerCase() === "sent back"
  );
};

  // Salutation has historically been stored with stray casing/whitespace
  // (e.g. "mr "). The editor's <select> only offers the canonical values, and
  // an unmatched value renders as the placeholder "Select" — so normalise
  // whatever is in the DB to the option value it means.
  const normaliseSalutation = (value) => {
    const raw = String(value || "").trim().toLowerCase().replace(/\.$/, "");
    if (!raw) return "";
    return ["mr", "ms", "mrs", "dr"].includes(raw)
      ? `${raw.charAt(0).toUpperCase()}${raw.slice(1)}.`
      : "";
  };


  // console.log("offers", offers);
const emptyOfferForm = {

  

  candidateId: null,
  candidate_name: "",
  email: "",
  mobile: "",
  address: "",
  education: "",
  notice_period: "",
  

  position_offered: "",
  designation: "",
  grade: "",

  experience: "",
  relevant_experience: "",

  

  current_location: "",
  current_company: "",

  location_offered: "",
  offered_company: "",

  

  business_unit: "",
  division: "",
  department: "",

  

  offer_type: "regular",

  expected_doj: "",

  work_mode: "",

  

  current_ctc_fixed: "",
  current_ctc_variable: "",
  current_ctc_variable_amount: "",
  current_ctc_total: "",

  expected_ctc_fixed: "",
  expected_ctc_variable: "",
  expected_ctc_variable_amount: "",
  expected_ctc_total: "",

  offered_ctc_fixed: "",
  offered_ctc_variable: "",
  offered_ctc_variable_amount: "",
  offered_ctc_total: "",

  // Section F of Annexure-A - the two variable pay lines that sit next to
  // the billable bonus. Both are annual amounts.
  variable_annual_pay_amount: "",
  variable_retention_bonus_amount: "",
  

  

  joining_bonus: "No",

  joining_bonus_amount: "",

  

  retention_bonus: "No",

  retention_total: "",

  retention_installment1_date: "",
  retention_installment1_amount: "",

  retention_installment2_date: "",
  retention_installment2_amount: "",

  retention_installment3_date: "",
  retention_installment3_amount: "",

  

  training_period: "",

  training_amount: "",

  internship_period: "",

  internship_stipend: "",

  year1_fixed: "",
  year1_variable_type: "",
  year1_variable_amount: "",
  year1_ctc: "",

  year2_fixed: "",
  year2_variable_type: "",
   year2_variable_amount: "",
  year2_ctc: "",

  year3_fixed: "",
  year3_variable_type: "",
  year3_variable_amount: "",
  year3_ctc: "",

  year4_fixed: "",
  year4_variable_type: "",
  year4_variable_amount: "",
  year4_ctc: "",

  

  aadhaar: null,
  resume: null,
  panCardFile: null,
  panCardName: "",
  aadhaarCardFile: null,
  aadhaarCardName: "",

  

  bu_head: "",

  hr_email: "",

  hiring_manager_name: "",
  hiring_manager_email: "",
  division_head_name: "",
  division_head_email: "",
}; 

  const [offerLetterForm, setOfferLetterForm] = useState({ ...emptyOfferForm });
  const [approvingAndSending, setApprovingAndSending] = useState(false);
  const [submittingOffer, setSubmittingOffer] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);
  const [releasingOffer, setReleasingOffer] = useState(false);
  const [headcountOptions, setHeadcountOptions] = useState({ businessUnits: [], divisions: [], departments: [],  divisionHeads: {} });
  const [additionalFiles, setAdditionalFiles] = useState([]);
  const [buHeads, setBuHeads] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role;
  const userEmail = user?.email;
  const EMPTY_APPROVER = { name: "", email: "" };
  
    // console.log("========== OFFER ACCESS DEBUG ==========");
    // console.log("Logged in user:", user);
    // console.log("User role:", userRole);
    // console.log("User email:", userEmail);
    // console.log(
    //   "Is Recruiter:",
    //   hasRole(userRole, ["recruiter"])
    // );
    // console.log("========================================");

  const isTA = hasRole(userRole, ["recruiter"]);
  const isHR = hasRole(userRole, ["hr", "hr_manager", "admin_user", "business_user", "super_admin"]);

  const normalizedUserEmail = String(userEmail || "").trim().toLowerCase();

  const isMyCreatedOffer = (offer) => {
  const createdBy = String(
    offer?.created_by ||
    offer?.createdBy ||
    ""
  )
    .trim()
    .toLowerCase();

  return createdBy === normalizedUserEmail;
};


const visibleOffers = isTA
  ? offers.filter(isMyCreatedOffer)
  : offers;

  

  const isOfferCreatedByMe = (offer) =>
    String(offer?.created_by || offer?.createdBy || "")
      .trim()
      .toLowerCase() === normalizedUserEmail;



      //offer submit and appproval
    
  // ============================================================
  // BUILD SAFE OFFER UPDATE PAYLOAD
  // - Converts empty DATE fields to null so MySQL never receives ''
  // - Keeps the existing workflow approvers when a returned offer
  //   is edited and sent back into the same workflow.
  // ============================================================
  const buildOfferUpdatePayload = (form) => {
    const dateFields = [
      "expected_doj",
      "retention_installment1_date",
      "retention_installment2_date",
      "retention_installment3_date",
      "possible_revenue_start_date",
      "start_date",
      "date",
      "hr_released_at",
      "offer_accepted_at",
      "offer_rejected_at",
    ];

    const payload = { ...(form || {}) };

    dateFields.forEach((field) => {
      if (Object.prototype.hasOwnProperty.call(payload, field)) {
        const value = payload[field];

        if (value === "" || value === undefined) {
          payload[field] = null;
        } else if (
          typeof value === "string" &&
          value.includes("T")
        ) {
          payload[field] = value.split("T")[0];
        }
      }
    });

    // The editor uses both naming styles in different places.
    // Keep both so the backend receives the existing workflow approvers.
    payload.stage1_email =
      payload.stage1_email ||
      payload.stage1Email ||
      null;

    payload.stage2_email =
      payload.stage2_email ||
      payload.stage2Email ||
      null;

    payload.stage3_email =
      payload.stage3_email ||
      payload.stage3Email ||
      null;

    payload.stage1Email = payload.stage1_email;
    payload.stage2Email = payload.stage2_email;
    payload.stage3Email = payload.stage3_email;

    return payload;
  };

const saveAndResubmitReturnedOffer = async () => {
  if (!editingOfferId || !editingOffer) {
    toast.error("Offer information is missing");
    return;
  }

  const dateErrors = validateEditDates();
  if (dateErrors.length > 0) {
    toast.error(dateErrors.join(" | "));
    return;
  }

  try {
    setEditOfferSaving(true);

    // ================================================
    // 1. SAVE CHANGES
    // ================================================

    if (canRecruiterEdit(editingOffer)) {

      await offersAPI.updateDraft(
        editingOfferId,
        buildOfferUpdatePayload(offerLetterForm)
      );

    } else if (editOfferStage === 1) {

      await offersAPI.updateStage1(
        editingOfferId,
        offerLetterForm
      );

    } else if (editOfferStage === 2) {

      await offersAPI.updateStage2(
        editingOfferId,
        offerLetterForm
      );

    } else if (editOfferStage === 3) {

      await offersAPI.updateStage3(
        editingOfferId,
        offerLetterForm
      );

    } else {

      throw new Error(
        "Invalid workflow stage"
      );
    }

    // ================================================
    // 2. RESUBMIT
    //
    // Backend decides:
    //
    // current_stage 0 -> Stage 1
    // current_stage 1 -> Stage 2
    // current_stage 2 -> Stage 3
    // ================================================

    const response =
      await offersAPI.submitForApproval(
        editingOfferId
      );

    toast.success(
      response.data?.message ||
      "Offer updated and sent for approval"
    );

    // ================================================
    // 3. CLOSE
    // ================================================

    setShowEditOfferModal(false);
    setEditingOfferId(null);
    setEditingOffer(null);
    setEditOfferStage(0);

    // ================================================
    // 4. REFRESH
    // ================================================

    await fetchOffers();

  } catch (error) {

    console.error(
      "Update & Resubmit Error:",
      error
    );

    toast.error(
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update and resubmit offer"
    );

  } finally {

    setEditOfferSaving(false);
  }
};

// ============================================================
// EDIT PERMISSION CHECKS
// ============================================================

        // A draft is owned by whoever created it and has not entered the approval
        // flow yet, so its creator must always be able to reopen and finish it —
        // even when their role is not literally "recruiter".
        const canRecruiterEdit = (offer) =>
          (isTA ||
            String(offer?.offer_status || "").trim() === "Draft") &&
          isOfferCreatedByMe(offer) &&
          ["Draft", "Sent Back"].includes(
            String(offer?.offer_status || "")
          );

        // True when the logged-in user is the active delegate for a stage
        const isStageDelegate = (offer, stageNum) =>
          !!offer?.[`delegated_from_stage${stageNum}`];

        // Email of the person who delegated this offer's current stage to me
        const getDelegatedFromForOffer = (offer) => {
          const cs = Number(offer?.current_stage);
          if (![1, 2, 3].includes(cs)) return null;
          return offer?.[`delegated_from_stage${cs}`] || null;
        };

        // Email the logged-in user delegated this offer's current stage away to
        const getDelegatedAwayForOffer = (offer) => {
          const cs = Number(offer?.current_stage);
          if (![1, 2, 3].includes(cs)) return null;
          return offer?.[`delegated_to_stage${cs}`] || null;
        };

        const canHiringManagerEdit = (offer) =>
          Number(offer?.current_stage) === 1 &&
          String(offer?.stage1_status || "").trim() === "Pending" &&
          (String(offer?.stage1_email || "")
            .trim()
            .toLowerCase() === normalizedUserEmail ||
            isStageDelegate(offer, 1));

        const canBUHeadEdit = (offer) =>
          Number(offer?.current_stage) === 2 &&
          String(offer?.stage2_status || "").trim() === "Pending" &&
          (String(offer?.stage2_email || "")
            .trim()
            .toLowerCase() === normalizedUserEmail ||
            isStageDelegate(offer, 2));

        const canHREdit = (offer) =>
          Number(offer?.current_stage) === 3 &&
          String(offer?.stage3_status || "").trim() === "Pending" &&
          (String(offer?.stage3_email || "")
            .trim()
            .toLowerCase() === normalizedUserEmail ||
            isStageDelegate(offer, 3));

        // ============================================================
        // GET CURRENT EDIT ROLE
        // ============================================================

        const getOfferEditRole = (offer) => {
          if (canRecruiterEdit(offer)) {
            return "recruiter";
          }

          if (canHiringManagerEdit(offer)) {
            return "hiring_manager";
          }

          if (canBUHeadEdit(offer)) {
            return "bu_head";
          }

          if (canHREdit(offer)) {
            return "hr";
          }

          return null;
        };

        // ============================================================
        // CAN EDIT OFFER
        // ============================================================

        const canEditOffer = (offer) => {
          return Boolean(getOfferEditRole(offer)) && mayPerform("offer", "manage");
        };

  const COMPANIES = [
    { value: "uss", label: "Univision Systems & Solutions (USS)" },
    { value: "eldaas", label: "Eldaas Technologies" },
  ];

  const getTemplateOptions = (company) => {
    if (company === "eldaas") {
      return [
        { value: "regular", label: "Regular" },
        { value: "service_agg", label: "Service Agreement" },
      ];
    }
    return [
      { value: "with_agreement", label: "With Agreement" },
      { value: "without_agreement", label: "Without Agreement" },
    ];
  };

const openOfferLetterPopup = (offer) => {
    setSelectedOffer(offer);
    setMailData({
      to: offer.email_id || "",
      cc: "",
      subject: `Offer Letter - ${offer.position || offer.position_offered}`,
      body: `Dear ${offer.custom_first_name || offer.candidate_name},

Congratulations!

We are pleased to offer you the position of ${offer.position || offer.position_offered}.

Please find the attached offer letter along with the offer details below.

Regards,
HR Team`,
      file: null
    });
    setShowMailModal(true);
  };

  const fetchOffers = async () => {
    try {
      setLoading(true);
      let res;
      if (activeTab === "accepted") {

            res = await offersAPI.getAcceptedByMe();

          } else if (activeTab === "pending") {

            res = await offersAPI.getMyPending();

          } else {

            res = await offersAPI.getAll({
              scope: "global"
            });

          }


          const responseData = res.data;


          
          if (activeTab === "pending") {

            setOffers(
              responseData?.offers || []
            );

          } else {

            setOffers(
              Array.isArray(responseData)
                ? responseData
                : []
            );

          }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load offers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useEffect(() => {

    if (offerLetterForm.offer_type === "conditional") {

        loadConditionalMaster();

    }

}, [offerLetterForm.offer_type]);

  useEffect(() => {
    const fetchBuHeads = async () => {
      const { business_unit, division } = offerLetterForm;

      // console.log("BU HEAD LOAD INPUT:", {
      //   business_unit,
      //   division,
      // });

      if (!business_unit || !division) {
        setBuHeads([]);
        return;
      }

      try {
        const params = { business_unit, division };
        // console.log("BU HEAD API PARAMS:", params);
        const res = await workflowMasterAPI.getOptions(params);
        // console.log("BU HEADS RESPONSE:", res.data);
        setBuHeads(res.data.buHeads || []);
      } catch (error) {
        // console.error("Failed to fetch BU Heads:", error);
        toast.error("Could not load BU Heads for the selected division.");
        setBuHeads([]);
      }
    };

    if (showCreateOfferModal) {
      fetchBuHeads();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerLetterForm.business_unit, offerLetterForm.division, showCreateOfferModal]);


  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  

  const canAssignStage = (offer) => {
    const loginEmail = userEmail?.toLowerCase();

    // A draft has not entered the approval flow, so there is no stage to
    // assign. Without this, the legacy `!stage1_status` fallback below would
    // match every draft (its stage1_status is NULL) and open the unrelated
    // assign-stage modal. The creator submits the draft instead.
    if (String(offer?.offer_status || "").trim() === "Draft") {
      return false;
    }

    if (!offer.offer_id || offer.overall_status === "Not Started") {
      return true;
    }
    if (
      offer.stage1_status === "Approved" &&
      offer.current_stage === 2 &&
      offer.stage1_approved_by?.toLowerCase() === loginEmail &&
      offer.stage2_status !== "Pending"
    ) {
      return true;
    }
    if (
      offer.stage2_status === "Approved" &&
      offer.current_stage === 3 &&
      offer.stage2_approved_by?.toLowerCase() === loginEmail &&
      offer.stage3_status !== "Pending"
    ) {
      return true;
    }
    if (!offer.stage1_status || offer.stage1_status === "-") {
      return true;
    }
    return false;
  };

    const isStage3Approver = (offer) =>
      String(offer?.stage3_email || "")
        .trim()
        .toLowerCase() === normalizedUserEmail;

    const canReleaseOffer = (offer) => {
      return (
        isHR &&
        isStage3Approver(offer) &&
        offer.offer_status === "Ready for HR Release" &&
        offer.stage1_status === "Approved" &&
        offer.stage2_status === "Approved" &&
        offer.stage3_status === "Approved"
      );
    };
     
    
    const isOfferLetterSender = (offer) => {
        return (
          isHR &&
          isStage3Approver(offer) &&
          offer.overall_status === "Approved" &&
          offer.stage1_status === "Approved" &&
          offer.stage2_status === "Approved" &&
          offer.stage3_status === "Approved"
        );
      };

  const openMailPopup = (offer) => {
    setSelectedOffer(offer);
    setMailData({
      to: "",
      cc: userEmail || "",
      subject: `Offer Approval - ${offer.position || offer.position_offered}`,
      body: `Dear Sir/Madam,

      Please review the offer details below for approval.

      Kindly approve or reject the offer.

      Regards,
      HR Team`,
      file: null
    });
    setShowMailModal(true);
  };

  const sendWorkflowMail = async () => {
    if (sendingMail) return;
    setSendingMail(true);

    if (!mailData.to) {
      toast.error("Select email");
      setSendingMail(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("candidate_id", selectedOffer.candidate_id);
      formData.append("offer_id", selectedOffer.offer_id);
      formData.append("cc", mailData.cc);
      formData.append("subject", mailData.subject);
      formData.append("body", mailData.body);

      if (mailData.file) {
        formData.append("offerFile", mailData.file);
      }

      if (selectedOffer.offer_status === "Ready for HR Release" || selectedOffer.overall_status === "Approved") {
        formData.append("to", mailData.to);
        await offersAPI.sendOfferLetter(formData);
      } else {
        formData.append("nextEmail", mailData.to);
        const workflowId = selectedOffer.offer_id || selectedOffer.candidate_id;
        await offersAPI.workflow(workflowId, formData);
      }

      toast.success("Mail sent successfully");
      setShowMailModal(false);
      fetchOffers();
    } catch (error) {
      console.error(error);
      toast.error("Mail failed");
    } finally {
      setSendingMail(false);
    }
  };

  const handleRemove = (id) => {
    setOfferToDelete(id);
  };

  const confirmRemoveOffer = async () => {
    if (!offerToDelete || deletingOffer) return;
    try {
      setDeletingOffer(true);
      await offersAPI.delete(offerToDelete);
      toast.success("Offer deleted successfully");
      setOfferToDelete(null);
      fetchOffers();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete offer");
    } finally {
      setDeletingOffer(false);
    }
  };


  // ============================================================
  // REJECTION / RETURN-TO-SENDER FLOW
  // ============================================================

  // ============================================================
  // STAGE 1 DELEGATION
  // One button in the page header opens the delegation workspace.
  // The workspace receives the current visible Stage 1 offers and
  // handles multi-select candidates + Hiring Managers.
  // ============================================================

  const canOpenStage1Delegation = () => {
    return visibleOffers.some((offer) => {
      const stage = Number(offer?.current_stage ?? 1);
      const status = String(offer?.stage1_status || "")
        .trim()
        .toLowerCase();
      return (
        stage === 1 &&
        status === "pending" &&
        Number(offer?.offer_accepted) !== 1 &&
        Number(offer?.offer_rejected) !== 1
      );
    });
  };

  const canOpenStage2Delegation = () => {
    return visibleOffers.some((offer) => {
      const stage = Number(offer?.current_stage ?? 0);
      const status = String(offer?.stage2_status || "")
        .trim()
        .toLowerCase();
      const isAssignee =
        String(offer?.stage2_email || "").trim().toLowerCase() ===
        normalizedUserEmail;
      return (
        stage === 2 &&
        status === "pending" &&
        isAssignee &&
        Number(offer?.offer_accepted) !== 1 &&
        Number(offer?.offer_rejected) !== 1
      );
    });
  };

  const canOpenStage3Delegation = () => {
    return visibleOffers.some((offer) => {
      const stage = Number(offer?.current_stage ?? 0);
      const status = String(offer?.stage3_status || "")
        .trim()
        .toLowerCase();
      const isAssignee =
        String(offer?.stage3_email || "").trim().toLowerCase() ===
        normalizedUserEmail;
      return (
        stage === 3 &&
        status === "pending" &&
        isAssignee &&
        Number(offer?.offer_accepted) !== 1 &&
        Number(offer?.offer_rejected) !== 1
      );
    });
  };

  const handleOpenRejectModal = (offer) => {
    const offerId = offer?.offer_id || offer?.id;

    if (!offerId) {
      toast.error("Offer ID is missing");
      return;
    }

    setRejectingOffer(offer);
    setRejectionReason("");
    setShowRejectModal(true);
  };

  const handleCloseRejectModal = () => {
    if (rejecting) return;

    setShowRejectModal(false);
    setRejectingOffer(null);
    setRejectionReason("");
  };

  const handleRejectWorkflow = async () => {
    const offerId =
      rejectingOffer?.offer_id ||
      rejectingOffer?.id;

    if (!offerId) {
      toast.error("Offer ID is missing");
      return;
    }

    const reason = rejectionReason.trim();

    if (!reason) {
      toast.error("Please enter a rejection reason");
      return;
    }

    if (reason.length > 2000) {
      toast.error("Rejection reason cannot exceed 2000 characters");
      return;
    }

    try {
      setRejecting(true);

      const response = await offersAPI.rejectWorkflow(
        offerId,
        { reason }
      );

      toast.success(
        response.data?.message ||
        "Offer rejected and returned to the sender"
      );

      const rejectedFrom = getDelegatedFromForOffer(rejectingOffer);
      if (rejectedFrom) {
        toast.info(
          `Delegated task: Stage ${rejectingOffer.current_stage} rejected on behalf of ${rejectedFrom}`
        );
      }

      // Close/reset the modal directly. Do not call
      // handleCloseRejectModal() while rejecting=true.
      setShowRejectModal(false);
      setRejectingOffer(null);
      setRejectionReason("");

      // Refresh using the current tab.
      await fetchOffers();

    } catch (error) {
      console.error("Reject Workflow Error:", error);
      console.error("Backend Response:", error.response?.data);

      toast.error(
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to reject and return the offer"
      );
    } finally {
      setRejecting(false);
    }
  };

  const openCreateOfferModal = async () => {
    setOfferLetterForm({ ...emptyOfferForm });
    setEditingOfferId(null);
    setEditingDraftId(null);
    setShowCreateOfferModal(true);

    try {
      const [candidatesRes, hcRes] = await Promise.all([
        candidatesAPI.getAll(),
        headcountAPI.getOptions(),
      ]);
      setCandidates(candidatesRes.data || []);
      setHeadcountOptions(hcRes.data || { businessUnits: [], divisions: [], departments: [] });
    } catch {
      toast.error("Failed to load data");
    }
  };

  /* A draft is resumed in the Create Offer modal itself — same page, same
 * fields, everything editable — so there is no separate editor and nothing
 * to re-type. Only the modal that gets opened differs. */
const openOfferModalForEditing = async (offerId, { asDraft = false } = {}) => {
    try {
      const [res, hcRes, candRes] = await Promise.all([
        offersAPI.getById(offerId),
        headcountAPI.getOptions(),
        asDraft ? candidatesAPI.getAll() : Promise.resolve({ data: null }),
      ]);

      const offer = res.data || {};

      // The Create Offer modal needs the candidate list to resolve the
      // already-selected candidate back to a name.
      if (candRes?.data) {
        setCandidates(candRes.data || []);
      }

      const normalizedOffer = {
        ...offer,

        candidateId: offer.candidate_id ?? offer.candidateId ?? null,
        candidate_name: offer.candidate_name || "",
        name: offer.candidate_name || "",
        position_offered: offer.position_offered || "",
        role: offer.position_offered || "",
        email: offer.email || offer.email_id || offer.candidate_email || "",
        mobile: offer.mobile || offer.mobile_number || "",
        address: offer.address || "",
        education: offer.education || "",
        notice_period: offer.notice_period || "",
        experience: offer.experience || "",
        relevant_experience: offer.relevant_experience || "",
        grade: offer.grade || "",
        salutation: normaliseSalutation(offer.salutation),

        hiring_manager_name: offer.hiring_manager_name || "",
        hiring_manager_email: offer.hiring_manager_email || "",

        business_unit: offer.business_unit || "",
        division: offer.division || "",
        department: offer.department || "",

        current_location: offer.current_location || "",
        current_company: offer.current_company || "",
        location_offered: offer.location_offered || "",
        offered_company: offer.offered_company || "",
        work_mode: offer.work_mode || "",
        expected_doj: offer.expected_doj
          ? String(offer.expected_doj).split("T")[0]
          : "",
        reporting_manager: offer.reporting_manager || "",
        bill_rate_per_month: offer.bill_rate_per_month || "",

        current_ctc_fixed: offer.current_ctc_fixed || "",
        current_ctc_variable: offer.current_ctc_variable || "",
        current_ctc_variable_amount: offer.current_ctc_variable_amount || "",
        current_ctc_total: offer.current_ctc_total || "",

        expected_ctc_fixed: offer.expected_ctc_fixed || "",
        expected_ctc_variable: offer.expected_ctc_variable || "",
        expected_ctc_variable_amount: offer.expected_ctc_variable_amount || "",
        expected_ctc_total: offer.expected_ctc_total || "",

        offered_ctc_fixed: offer.offered_ctc_fixed || "",
        offered_ctc_variable: offer.offered_ctc_variable || "",
        offered_ctc_variable_amount: offer.offered_ctc_variable_amount ?? "",
        offered_ctc_total: offer.offered_ctc_total || "",

        variable_annual_pay_amount: offer.variable_annual_pay_amount || "",
        variable_retention_bonus_amount:
          offer.variable_retention_bonus_amount || "",

        joining_bonus: offer.joining_bonus || "No",
        joining_bonus_amount: offer.joining_bonus_amount || "",

        retention_bonus: offer.retention_bonus || "No",
        retention_total: offer.retention_total || "",
        retention_installment1_date: offer.retention_installment1_date
          ? String(offer.retention_installment1_date).split("T")[0]
          : "",
        retention_installment1_amount: offer.retention_installment1_amount || "",
        retention_installment2_date: offer.retention_installment2_date
          ? String(offer.retention_installment2_date).split("T")[0]
          : "",
        retention_installment2_amount: offer.retention_installment2_amount || "",
        retention_installment3_date: offer.retention_installment3_date
          ? String(offer.retention_installment3_date).split("T")[0]
          : "",
        retention_installment3_amount: offer.retention_installment3_amount || "",

        training_period: offer.training_period || "",
        training_amount: offer.training_amount || "",
        internship_period: offer.internship_period || "",
        internship_stipend: offer.internship_stipend || "",

        year1_fixed: offer.year1_fixed || "",
        year1_variable_type: offer.year1_variable_type || "",
        year1_variable_amount: offer.year1_variable_amount || "",
        year1_ctc: offer.year1_ctc || "",

        year2_fixed: offer.year2_fixed || "",
        year2_variable_type: offer.year2_variable_type || "",
        year2_variable_amount: offer.year2_variable_amount || "",
        year2_ctc: offer.year2_ctc || "",

        year3_fixed: offer.year3_fixed || "",
        year3_variable_type: offer.year3_variable_type || "",
        year3_variable_amount: offer.year3_variable_amount || "",
        year3_ctc: offer.year3_ctc || "",

        year4_fixed: offer.year4_fixed || "",
        year4_variable_type: offer.year4_variable_type || "",
        year4_variable_amount: offer.year4_variable_amount || "",
        year4_ctc: offer.year4_ctc || "",

service_agreement: offer.service_agreement || "",
        offer_type: offer.offer_type || "regular",
        company: offer.company || "uss",
        templateType: offer.template_type || offer.templateType || "",

        stage1_email: offer.stage1_email || "",
        stage2_email: offer.stage2_email || "",
        stage3_email: offer.stage3_email || "",

        // Keep both aliases because the workflow/editor code uses
        // stage1Email/stage2Email/stage3Email in some places.
        stage1Email: offer.stage1_email || offer.stage1Email || "",
        stage2Email: offer.stage2_email || offer.stage2Email || "",
        stage3Email: offer.stage3_email || offer.stage3Email || "",
      };

      const stage = Number(offer.current_stage || 0);

      setEditingOffer(offer);
      setOfferLetterForm(normalizedOffer);
      setHeadcountOptions(
        hcRes.data || {
          businessUnits: [],
          divisions: [],
          departments: [],
          divisionHeads: {},
        }
      );
      setEditingOfferId(offerId);
      setEditOfferStage(stage);

      if (asDraft) {
        setEditingDraftId(offerId);
        setShowCreateOfferModal(true);
        return;
      }

      setShowEditOfferModal(true);
    } catch (error) {
      console.error("Failed to load offer details:", error);
      toast.error(
        error?.response?.data?.error || "Failed to load offer details"
      );
    }
  };

  /* Existing (non-draft) offers keep the stage editor. */
  const openEditOfferModal = (offerId) =>
    openOfferModalForEditing(offerId, { asDraft: false });

  /* Drafts reopen the Create Offer modal, pre-filled. */
  const openDraftOfferModal = (offerId) =>
    openOfferModalForEditing(offerId, { asDraft: true });

  const closeEditOfferModal = () => {
    if (editOfferSaving) return;
    setShowEditOfferModal(false);
    setEditingOfferId(null);
    setEditingOffer(null);
    setEditOfferStage(0);
  };

  const saveStageEditor = async () => {
    if (!editingOfferId) return;

    const dateErrors = validateEditDates();
    if (dateErrors.length > 0) {
      toast.error(dateErrors.join(" | "));
      return;
    }

    try {
      setEditOfferSaving(true);

      if (canRecruiterEdit(editingOffer)) {
        const updatePayload =
          buildOfferUpdatePayload(offerLetterForm);

        await offersAPI.updateDraft(
          editingOfferId,
          updatePayload
        );

        toast.success("Offer updated successfully");
        closeEditOfferModal();
        await fetchOffers();
        return;
      }

      if (editOfferStage === 1) {
        if (typeof offersAPI.updateStage1 !== "function") {
          throw new Error("Stage 1 update API is not configured in client.js");
        }
        await offersAPI.updateStage1(
          editingOfferId,
          buildOfferUpdatePayload(offerLetterForm)
        );
      } else if (editOfferStage === 2) {
        if (typeof offersAPI.updateStage2 !== "function") {
          throw new Error("Stage 2 update API is not configured in client.js");
        }
        await offersAPI.updateStage2(
          editingOfferId,
          buildOfferUpdatePayload(offerLetterForm)
        );
      } else if (editOfferStage === 3) {
        if (typeof offersAPI.updateStage3 !== "function") {
          throw new Error("Stage 3 update API is not configured in client.js");
        }
        await offersAPI.updateStage3(
          editingOfferId,
          buildOfferUpdatePayload(offerLetterForm)
        );
      } else {
        throw new Error("Invalid offer edit stage");
      }

      toast.success(`Stage ${editOfferStage} offer updated successfully`);
      closeEditOfferModal();
      await fetchOffers();
    } catch (error) {
      console.error("Offer update error:", error);
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update offer"
      );
    } finally {
      setEditOfferSaving(false);
    }
  };

  const getCandidateDisplayName = (candidate) => {
    const first = candidate.custom_first_name || candidate.first_name || "";
    const last = candidate.custom_last_name || candidate.last_name || "";
    return `${first} ${last}`.trim();
  };

  const getOfferEmail = (offer) => {
    if (!offer) return "-";
    return (
      offer.candidate_email ||
      offer.email ||
      offer.email_id ||
      (offer.candidate && (offer.candidate.email || offer.candidate_email)) ||
      "-"
    );
  };

  const filteredCandidateSuggestions = candidates.filter((candidate) => {
  const query = (offerLetterForm.candidate_name || "").trim().toLowerCase();
    if (!query) return true;
    const name = getCandidateDisplayName(candidate).toLowerCase();
    return name.includes(query);
  });


const selectCandidateForOffer = async (candidate) => {

  const name =
    getCandidateDisplayName(candidate);


  try {

    let hiringManagerName = "";
    let hiringManagerEmail = "";


    if (candidate.job_id) {

      const jobRes =
        await jobsAPI.getById(
          candidate.job_id
        );


      hiringManagerName =
        jobRes.data?.hiring_manager_name ||
        "";

      hiringManagerEmail =
        jobRes.data?.hiring_manager_email ||
        "";

    }


    setOfferLetterForm(prev => ({

      ...prev,

      candidateId:
        candidate.id,

      candidate_name:
        name,

      email:
        candidate.email ||
        candidate.email_id ||
        "",

      mobile:
        candidate.mobile ||
        candidate.mobile_number ||
        "",

      address:
        candidate.address ||
        candidate.current_address ||
        "",

      position_offered:
        candidate.position || "",

      hiring_manager_name:
        hiringManagerName,

      hiring_manager_email:
        hiringManagerEmail,

    }));


    setShowCandidateSuggestions(false);

  } catch (error) {

    console.error(
      "Hiring Manager lookup failed:",
      error
    );


    setOfferLetterForm(prev => ({

      ...prev,

      candidateId:
        candidate.id,

      candidate_name:
        name,

      email:
        candidate.email ||
        candidate.email_id ||
        "",

      mobile:
        candidate.mobile ||
        candidate.mobile_number ||
        "",

      address:
        candidate.address ||
        candidate.current_address ||
        "",

      position_offered:
        candidate.position || "",

      hiring_manager_name:
        candidate.hiring_manager_name || "",

      hiring_manager_email:
        candidate.hiring_manager_email || "",

    }));


    setShowCandidateSuggestions(false);

  }

};


  const buildOfferLetterPdfHtml = (html) => {
    const previewContent = html || document.getElementById("offer-preview-content")?.innerHTML || offerPreviewHtml;
    return `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>body{margin:0;padding:0;font-family:Arial,sans-serif;}</style></head><body>${previewContent}</body></html>`;
  };

  const getOfferLetterFileName = () => {
    const safeName = (offerLetterForm.candidate_name || offerLetterForm.candidate_name).replace(/[^a-z0-9]/gi, "_") || "candidate";
    return offerLetterForm.templateType === "without_agreement" || offerLetterForm.templateType === "regular"
      ? `Formal_Offer_Letter-${safeName}.pdf`
      : `Conditional_Offer_Letter-${safeName}.pdf`;
  };

  // console.log("offerLetterForm", offerLetterForm);
  const saveOfferDraft = async (asDraft = false) => {
    if (editingOfferId) {
      // The RAW per-period amount is what gets stored. The annual figure is
      // derived from it, so saving the same offer twice can never multiply
      // the bonus a second time.
      const varAmt = Number(offerLetterForm.offered_ctc_variable_amount || 0) || 0;
      const varType = offerLetterForm.offered_ctc_variable || "";

      // The offered CTC is the recruiter's own number - never the expected
      // CTC, which is only the candidate's ask.
      const fixedPart = Number(offerLetterForm.offered_ctc_fixed || 0) || 0;
      const totalAmt = computeOfferCtcTotals({
        fixedCtc: offerLetterForm.offered_ctc_fixed,
        variableType: varType,
        variableAmount: varAmt,
        annualVariablePay: offerLetterForm.variable_annual_pay_amount,
        annualRetentionBonus:
          offerLetterForm.variable_retention_bonus_amount,
      }).fixedPlusVariable;
      const data = {
      candidateId: offerLetterForm.candidateId,
      candidate_name: offerLetterForm.candidate_name,
      email: offerLetterForm.email || null,
      mobile: offerLetterForm.mobile || null,
      address: offerLetterForm.address || null,
      notice_period: offerLetterForm.notice_period || null,
      position_offered: offerLetterForm.position_offered,
      experience: offerLetterForm.experience,
      relevant_experience: offerLetterForm.relevant_experience,
      grade: offerLetterForm.grade,
      hiring_manager_name: offerLetterForm.hiring_manager_name,
      hiring_manager_email: offerLetterForm.hiring_manager_email,
      current_company: offerLetterForm.current_company || null,
      offered_company: offerLetterForm.offered_company || null,

      current_ctc_fixed: offerLetterForm.current_ctc_fixed || null,
      current_ctc_variable: offerLetterForm.current_ctc_variable || null,
      current_ctc_variable_amount: offerLetterForm.current_ctc_variable_amount || null,
      current_ctc_total: offerLetterForm.current_ctc_total || null,
      expected_ctc_fixed: offerLetterForm.expected_ctc_fixed || null,
      expected_ctc_variable: offerLetterForm.expected_ctc_variable || null,
      expected_ctc_variable_amount: offerLetterForm.expected_ctc_variable_amount || null,
      expected_ctc_total: offerLetterForm.expected_ctc_total || null,
      offered_ctc_fixed: fixedPart || null,
      offered_ctc_variable: varType || null,
      // 0 is a real amount ("no variable pay"), so only a blank field is sent
      // as null.
      offered_ctc_variable_amount:
        String(offerLetterForm.offered_ctc_variable_amount ?? "").trim() === ""
          ? null
          : varAmt,
      offered_ctc_total: totalAmt || null,
      variable_annual_pay_amount:
        offerLetterForm.variable_annual_pay_amount || null,
      variable_retention_bonus_amount:
        offerLetterForm.variable_retention_bonus_amount || null,
      joining_bonus: offerLetterForm.joining_bonus,
      joining_bonus_amount: offerLetterForm.joining_bonus_amount || null,
      retention_bonus: offerLetterForm.retention_bonus,
      retention_total: offerLetterForm.retention_total || null,
      retention_installment1_date: offerLetterForm.retention_installment1_date || null,
      retention_installment1_amount: offerLetterForm.retention_installment1_amount || null,
      retention_installment2_date: offerLetterForm.retention_installment2_date || null,
      retention_installment2_amount: offerLetterForm.retention_installment2_amount || null,
      retention_installment3_date: offerLetterForm.retention_installment3_date || null,
      retention_installment3_amount: offerLetterForm.retention_installment3_amount || null,
      training_period: offerLetterForm.training_period || null,
      training_amount: offerLetterForm.training_amount || null,
      internship_period: offerLetterForm.internship_period || null,
      internship_stipend: offerLetterForm.internship_stipend || null,
      year1_fixed: offerLetterForm.year1_fixed || null,
      year1_variable_type: offerLetterForm.year1_variable_type || null,
      year1_variable_amount: offerLetterForm.year1_variable_amount || null,
      year1_ctc: offerLetterForm.year1_ctc || null,
      year2_fixed: offerLetterForm.year2_fixed || null,
      year2_variable_type: offerLetterForm.year2_variable_type || null,
      year2_variable_amount: offerLetterForm.year2_variable_amount || null,
      year2_ctc: offerLetterForm.year2_ctc || null,
      year3_fixed: offerLetterForm.year3_fixed || null,
      year3_variable_type: offerLetterForm.year3_variable_type || null,
      year3_variable_amount: offerLetterForm.year3_variable_amount || null,
      year3_ctc: offerLetterForm.year3_ctc || null,
      year4_fixed: offerLetterForm.year4_fixed || null,
      year4_variable_type: offerLetterForm.year4_variable_type || null,
      year4_variable_amount: offerLetterForm.year4_variable_amount || null,
      year4_ctc: offerLetterForm.year4_ctc || null,

      business_unit: offerLetterForm.business_unit,
      division: offerLetterForm.division,
      department: offerLetterForm.department,
      expected_doj: offerLetterForm.expected_doj || null,
      
      service_agreement: offerLetterForm.service_agreement,
      
      reporting_manager: offerLetterForm.reporting_manager,
      current_location: offerLetterForm.current_location,
      location_offered: offerLetterForm.location_offered,
      work_mode: offerLetterForm.work_mode,
      bill_rate_per_month: offerLetterForm.bill_rate_per_month || null,
      stage1_email: offerLetterForm.stage1Email || null,
  
      offer_type: offerLetterForm.offer_type || "regular",
      template_type: offerLetterForm.templateType || "with_agreement",
      company: offerLetterForm.company || "uss",
      salutation: offerLetterForm.salutation || "",
      // Only promote a saved offer that is already in the flow. Resuming a
      // draft must leave its status alone — otherwise every save would push
      // the draft into approval and it could never be resumed again.
      ...(editingDraftId
        ? {}
        : {
            offer_status: "Pending Approval",
            overall_status: "In Progress",
            current_stage: 1,
            stage1_status: "Pending",
            stage2_status: "-",
            stage3_status: "-",
          }),
  
      stage1_approved_by: offerLetterForm.stage1_approved_by || null,
      stage2_approved_by: offerLetterForm.stage2_approved_by || null,
      stage3_approved_by: offerLetterForm.stage3_approved_by || null,
      approval_history: offerLetterForm.approval_history || [],
      approval_remarks: offerLetterForm.approval_remarks || [],
      hr_released_at: offerLetterForm.hr_released_at || null,
      hr_released_by: offerLetterForm.HR_released_by || null,
      offer_accepted_at: offerLetterForm.offer_accepted_at || null,
      offer_rejected_at: offerLetterForm.offer_rejected_at || null,
      offer_rejected_by: offerLetterForm.offer_rejected_by || null,
      offer_rejected_remarks: offerLetterForm.offer_rejected_remarks || null,
     };
      await offersAPI.updateDraft(editingOfferId, data);
      return editingOfferId;
    }

   // The RAW per-period amount is stored; the annual figure is derived from
   // it, so re-saving an offer can never multiply the bonus again.
   const varAmt = Number(offerLetterForm.offered_ctc_variable_amount || 0) || 0;

    const varType = offerLetterForm.offered_ctc_variable || "";
    const fixedPart = Number(offerLetterForm.offered_ctc_fixed || 0) || 0;
    const totalAmt = computeOfferCtcTotals({
      fixedCtc: offerLetterForm.offered_ctc_fixed,
      variableType: varType,
      variableAmount: varAmt,
      annualVariablePay: offerLetterForm.variable_annual_pay_amount,
      annualRetentionBonus: offerLetterForm.variable_retention_bonus_amount,
    }).fixedPlusVariable;
      const data = {

  candidateId:
    offerLetterForm.candidateId,

  candidate_name:
    offerLetterForm.candidate_name,

  email:
    offerLetterForm.email || null,

  mobile:
    offerLetterForm.mobile || null,

  address:
    offerLetterForm.address || null,

  notice_period:
    offerLetterForm.notice_period || null,

  position_offered:
    offerLetterForm.position_offered,

  experience:
    offerLetterForm.experience,

  relevant_experience:
    offerLetterForm.relevant_experience,

  grade:
    offerLetterForm.grade,

  hiring_manager_name:
    offerLetterForm.hiring_manager_name || null,

  hiring_manager_email:
    offerLetterForm.hiring_manager_email || null,


  current_company:
    offerLetterForm.current_company || null,

  offered_company:
    offerLetterForm.offered_company || null,


  current_ctc_fixed:
    offerLetterForm.current_ctc_fixed || null,

  current_ctc_variable:
    offerLetterForm.current_ctc_variable || null,

  current_ctc_variable_amount:
    offerLetterForm.current_ctc_variable_amount || null,

  current_ctc_total:
    offerLetterForm.current_ctc_total || null,


  expected_ctc_fixed:
    offerLetterForm.expected_ctc_fixed || null,

  expected_ctc_variable:
    offerLetterForm.expected_ctc_variable || null,

  expected_ctc_variable_amount:
    offerLetterForm.expected_ctc_variable_amount || null,

  expected_ctc_total:
    offerLetterForm.expected_ctc_total || null,


  offered_ctc_fixed:
    fixedPart || null,

  offered_ctc_variable:
    varType || null,

  // 0 is a real amount ("no variable pay"), so only a blank field is sent as
  // null.
  offered_ctc_variable_amount:
    String(offerLetterForm.offered_ctc_variable_amount ?? "").trim() === ""
      ? null
      : varAmt,

  offered_ctc_total:
    totalAmt || null,

  variable_annual_pay_amount:
    offerLetterForm.variable_annual_pay_amount || null,

  variable_retention_bonus_amount:
    offerLetterForm.variable_retention_bonus_amount || null,


  joining_bonus:
    offerLetterForm.joining_bonus,

  joining_bonus_amount:
    offerLetterForm.joining_bonus_amount || null,


  retention_bonus:
    offerLetterForm.retention_bonus,

  retention_total:
    offerLetterForm.retention_total || null,

  retention_installment1_date:
    offerLetterForm.retention_installment1_date || null,

  retention_installment1_amount:
    offerLetterForm.retention_installment1_amount || null,

  retention_installment2_date:
    offerLetterForm.retention_installment2_date || null,

  retention_installment2_amount:
    offerLetterForm.retention_installment2_amount || null,

  retention_installment3_date:
    offerLetterForm.retention_installment3_date || null,

  retention_installment3_amount:
    offerLetterForm.retention_installment3_amount || null,


  training_period:
    offerLetterForm.training_period || null,

  training_amount:
    offerLetterForm.training_amount || null,

  internship_period:
    offerLetterForm.internship_period || null,

  internship_stipend:
    offerLetterForm.internship_stipend || null,


  year1_fixed:
    offerLetterForm.year1_fixed || null,

  year1_variable_type:
    offerLetterForm.year1_variable_type || null,

  year1_variable_amount:
    offerLetterForm.year1_variable_amount || null,

  year1_ctc:
    offerLetterForm.year1_ctc || null,


  year2_fixed:
    offerLetterForm.year2_fixed || null,

  year2_variable_type:
    offerLetterForm.year2_variable_type || null,

  year2_variable_amount:
    offerLetterForm.year2_variable_amount || null,

  year2_ctc:
    offerLetterForm.year2_ctc || null,


  year3_fixed:
    offerLetterForm.year3_fixed || null,

  year3_variable_type:
    offerLetterForm.year3_variable_type || null,

  year3_variable_amount:
    offerLetterForm.year3_variable_amount || null,

  year3_ctc:
    offerLetterForm.year3_ctc || null,


  year4_fixed:
    offerLetterForm.year4_fixed || null,

  year4_variable_type:
    offerLetterForm.year4_variable_type || null,

  year4_variable_amount:
    offerLetterForm.year4_variable_amount || null,

  year4_ctc:
    offerLetterForm.year4_ctc || null,


  business_unit:
    offerLetterForm.business_unit,

  division:
    offerLetterForm.division,

  department:
    offerLetterForm.department,


  expected_doj:
    offerLetterForm.expected_doj || null,

  service_agreement:
    offerLetterForm.service_agreement || null,

  current_location:
    offerLetterForm.current_location || null,

  location_offered:
    offerLetterForm.location_offered || null,

  work_mode:
    offerLetterForm.work_mode || null,


  offer_type:
    offerLetterForm.offer_type || "regular",

  template_type:
    offerLetterForm.templateType || "with_agreement",

  company:
    offerLetterForm.company || "uss",

  salutation:
    offerLetterForm.salutation || "",

};  
    // console.log("Sending Offer Data");
    // console.log(data);

    // Ask the backend to park the offer as a Draft instead of pushing it
    // straight into the approval workflow. It skips mandatory-field and
    // approver validation; POST /offers/:id/submit re-runs both.
    if (asDraft) {
      data.save_as_draft = true;
    }

    const res = await offersAPI.create(data);
    return res.data.offerId;
  };

  // ============================================================
  // MANDATORY FIELDS FOR OFFER CREATION
  // These fields are required to generate the offer letter.
  // The recruiter cannot create an offer without filling these.
  // ============================================================
  const validateOfferForm = () => {
    const missing = [];

    if (!offerLetterForm.candidateId) missing.push("Candidate");
    if (!String(offerLetterForm.candidate_name || "").trim())
      missing.push("Candidate Name");
    if (!String(offerLetterForm.position_offered || "").trim())
      missing.push("Position Offered");
    if (!String(offerLetterForm.experience || "").trim())
      missing.push("Experience");
    if (!String(offerLetterForm.business_unit || "").trim())
      missing.push("Business Unit");
    if (!String(offerLetterForm.division || "").trim())
      missing.push("Division");
    if (!String(offerLetterForm.department || "").trim())
      missing.push("Department");
    if (!String(offerLetterForm.location_offered || "").trim())
      missing.push("Offered Location");
    if (!String(offerLetterForm.offered_company || "").trim())
      missing.push("Offered Company");
    if (!String(offerLetterForm.work_mode || "").trim())
      missing.push("Work Mode");
    if (!offerLetterForm.expected_doj) missing.push("Expected DOJ");

    const isConditional = offerLetterForm.offer_type === "conditional";

    // The compensation grid (offered_ctc_*) is only rendered for a regular
    // offer. A conditional offer states its pay as the Year 1-4 schedule that
    // loadConditionalMaster fills in, so requiring offered_ctc_* there would
    // leave fields on screen that do not exist and block every submission.
    if (!isConditional) {
      if (!String(offerLetterForm.offered_ctc_fixed || "").trim())
        missing.push("Offered Fixed Salary");
      if (!String(offerLetterForm.offered_ctc_variable || "").trim())
        missing.push("Offered Variable Type");
      // Mandatory, but 0 is a valid answer ("no variable pay"). Testing with
      // `value || ""` would read 0 as blank, so only a truly empty entry is
      // treated as missing.
      if (
        offerLetterForm.offered_ctc_variable_amount === null ||
        offerLetterForm.offered_ctc_variable_amount === undefined ||
        !String(offerLetterForm.offered_ctc_variable_amount).trim()
      )
        missing.push("Offered Variable Amount");
    }

    // Conditional offers additionally require the agreement details and a
    // Year 1 pay schedule from the conditional offer master.
    if (isConditional) {
      if (!String(offerLetterForm.training_period || "").trim())
        missing.push("Training Agreement Period");
      if (!String(offerLetterForm.internship_period || "").trim())
        missing.push("Internship Training Period");
      if (!String(offerLetterForm.year1_fixed || "").trim())
        missing.push("Year 1 Fixed Salary");
      if (!String(offerLetterForm.year1_variable_type || "").trim())
        missing.push("Year 1 Variable Type");
      if (!String(offerLetterForm.year1_variable_amount || "").trim())
        missing.push("Year 1 Variable Amount");
    }

    return missing;
  };

  // Date rules live apart from validateOfferForm because a bad date is not a
  // "missing field" — it needs its own message.
  const validateOfferDates = () => getOfferDateErrors(offerLetterForm);

  // Edit path enforces only the retention schedule ordering. The "no past
  // dates" rule is deliberately skipped: an offer can already be past its
  // joining date, and a stage approver must still be able to save other edits.
  const validateEditDates = () =>
    getOfferDateErrors(offerLetterForm, { requireFutureDates: false });

  const handleCreateOffer = async (e, asDraft = false) => {
    // The Draft button lives inside the form as type="button", so guard
    // against an undefined event when it is clicked.
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    // A draft may be saved incomplete — it exists to be finished later — so it
    // only needs a candidate. Every other gate applies to real submissions.
    if (!offerLetterForm.candidateId) {
      toast.error("Please select a candidate before saving a draft");
      return;
    }

    if (!asDraft) {
      // Block offer creation unless every mandatory offer letter field is filled
      const missingFields = validateOfferForm();
      if (missingFields.length > 0) {
        toast.error(
          `Please fill all mandatory fields before creating the offer: ${missingFields.join(", ")}`
        );
        return;
      }

      // Reject past dates and out-of-order retention installments.
      const dateErrors = validateOfferDates();
      if (dateErrors.length > 0) {
        toast.error(dateErrors.join(" | "));
        return;
      }
    }

    try {
      setSubmittingOffer(true);
      if (asDraft) setSavingDraft(true);
      const offerId = await saveOfferDraft(asDraft);

      // Upload any selected PAN / Aadhaar card files to AWS (stored on the offer).
      const pendingDocs = [
        { docType: "pan", file: offerLetterForm?.panCardFile },
        { docType: "aadhaar", file: offerLetterForm?.aadhaarCardFile },
      ].filter((d) => d.file);

      if (offerId && pendingDocs.length > 0) {
        for (const doc of pendingDocs) {
          try {
            await offersAPI.uploadDocument(offerId, doc.docType, doc.file);
          } catch (err) {
            toast.error(
              `${doc.docType.toUpperCase()} card upload failed: ${
                err?.response?.data?.error || err.message
              }`
            );
          }
        }
      }

      // Resumed draft + "Send for Approval": saveOfferDraft() above already
      // persisted the edits and deliberately left the status on Draft, so the
      // draft still has to be promoted. POST /offers/:id/submit re-runs the
      // mandatory-field and approver checks server-side, flips the offer to
      // Pending Approval at Stage 1 and mails the first approver. A failure
      // here must keep the modal open — the draft is still a draft.
      let submitted = false;
      if (editingDraftId && !asDraft && offerId) {
        await offersAPI.submitForApproval(offerId);
        submitted = true;
      }

      toast.success(
        submitted
          ? "Offer sent for approval"
          : editingDraftId
          ? "Draft saved"
          : editingOfferId
          ? "Offer updated"
          : asDraft
          ? "Offer saved as draft"
          : "Offer created and sent for approval"
      );
      setShowCreateOfferModal(false);
      setEditingOfferId(null);
      setEditingDraftId(null);
      fetchOffers();
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to save offer");
    } finally {
      setSubmittingOffer(false);
      setSavingDraft(false);
    }
  };

  const generatePreviewHtml = async () => {
    const isServiceAgreement = (offerLetterForm.company === "uss" && offerLetterForm.templateType === "with_agreement") ||
      (offerLetterForm.company === "eldaas" && offerLetterForm.templateType === "service_agg");

    const body = {
      name: offerLetterForm.candidate_name || offerLetterForm.candidate_name.trim(),
      location: offerLetterForm.location_offered || offerLetterForm.location.trim(),
      role: offerLetterForm.position_offered || offerLetterForm.role.trim(),
      date: offerLetterForm.date,
      templateType: offerLetterForm.templateType,
      company: offerLetterForm.company,
      hrDate: "",
      salutation: offerLetterForm.salutation,
      offerType: offerLetterForm.offer_type || "regular",
      joiningBonus: offerLetterForm.joining_bonus || "No",
      joiningBonusAmount: offerLetterForm.joining_bonus_amount || "",
      retentionBonus: offerLetterForm.retention_bonus || "No",
      retentionBonusAmount: offerLetterForm.retention_total || "",
      bond_period: isServiceAgreement ? offerLetterForm.bond_period_service : "",
      bond_clause: !isServiceAgreement ? offerLetterForm.bond_period : "",
      bond_amount: isServiceAgreement ? offerLetterForm.bond_amount : "",
    };

    if (offerLetterForm.company === "uss" && offerLetterForm.templateType === "with_agreement") {
      body.stipend = offerLetterForm.stipend;
      body.years = offerLetterForm.years;
      body.start_date = offerLetterForm.start_date;
    } else if (offerLetterForm.company === "uss" && offerLetterForm.templateType === "without_agreement") {
      body.fixedCTC = offerLetterForm.offered_ctc_fixed || offerLetterForm.fixedCTC;
      body.variableAmount = offerLetterForm.offered_ctc_variable_amount ?? "";
      body.variableType = offerLetterForm.offered_ctc_variable || "";
      body.annualVariablePay = offerLetterForm.variable_annual_pay_amount || "";
      body.annualRetentionBonus =
        offerLetterForm.variable_retention_bonus_amount || "";
      body.start_date = offerLetterForm.start_date;
    } else if (offerLetterForm.company === "eldaas") {
      body.fixedSalary = offerLetterForm.offered_ctc_fixed || offerLetterForm.fixedSalary;
      body.variableSalary = offerLetterForm.offered_ctc_variable_amount ?? "";
      body.variableType = offerLetterForm.offered_ctc_variable || "";
      body.annualVariablePay = offerLetterForm.variable_annual_pay_amount || "";
      body.annualRetentionBonus =
        offerLetterForm.variable_retention_bonus_amount || "";
      body.start_date = offerLetterForm.start_date;
    }

    const res = await offerLetterAPI.generatePreview(body);
    return res.data?.html || "";
  };

  const handlePreview = async () => {
    if (!offerLetterForm.candidate_name.trim()) { toast.error("Candidate name is required"); return; }
    if (!offerLetterForm.location.trim()) { toast.error("Location is required"); return; }
    if (!offerLetterForm.role.trim()) { toast.error("Role is required"); return; }
    if (!offerLetterForm.date) { toast.error("Offer date is required"); return; }
    if (!offerLetterForm.candidateId) { toast.error("Select a candidate"); return; }

    try {
      setGeneratingPreview(true);
      await saveOfferDraft();
      const html = await generatePreviewHtml();
      setOfferPreviewHtml(html);
      setShowCreateOfferModal(false);
      setShowOfferPreviewModal(true);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to generate preview");
    } finally {
      setGeneratingPreview(false);
    }
  };

  const handleApproveAndSend = async () => {
    if (!offerLetterForm.candidateId) {
      toast.error("Select a candidate");
      return;
    }
    if (!offerPreviewHtml) {
      toast.error("No preview to send");
      return;
    }

    try {
      setApprovingAndSending(true);
      const fullHtml = buildOfferLetterPdfHtml();
      const res = await offerLetterAPI.downloadPdf(fullHtml);
      const pdfFile = new File([res.data], getOfferLetterFileName(), { type: "application/pdf" });

      const formData = new FormData();
      if (!offerLetterForm.stage1Email) { toast.error("Select Stage 1 approver"); return; }
      if (!offerLetterForm.stage2Email) { toast.error("Select Stage 2 approver"); return; }
      if (!offerLetterForm.stage3Email) { toast.error("Select Stage 3 approver"); return; }

      formData.append("candidate_id", offerLetterForm.candidateId);
      formData.append("cc", userEmail || "");
      formData.append("subject", `Offer Approval - ${offerLetterForm.position_offered || offerLetterForm.role}`);
      formData.append("body",
        `Dear Sir/Madam,\n\nPlease review the offer details below for approval.\n\nCandidate Name : ${offerLetterForm.candidate_name || offerLetterForm.candidate_name}\nPosition       : ${offerLetterForm.position_offered || offerLetterForm.role}\nProposed Salary: ${offerLetterForm.offered_ctc_total || offerLetterForm.salary}\n\nKindly approve or reject the offer.\n\nRegards,\nHR Team`
      );
      if (pdfFile) formData.append("offerFile", pdfFile);

      for (const file of additionalFiles) {
        formData.append("additionalFiles", file);
      }

      await offersAPI.workflow(offerLetterForm.candidateId, formData);
      setShowOfferPreviewModal(false);
      setAdditionalFiles([]);
      fetchOffers();
      toast.success("Workflow started. Stage 1 approval mail sent.");
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.response?.data?.error || "Failed to start workflow");
    } finally {
      setApprovingAndSending(false);
    }
  };

  const handleDownloadOfferPdf = async () => {
    if (!offerPreviewHtml) return;
    try {
      setDownloadingPdf(true);
      const res = await offerLetterAPI.downloadPdf(buildOfferLetterPdfHtml());
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = getOfferLetterFileName();
      link.click();
      window.URL.revokeObjectURL(url);
      toast.success("PDF downloaded");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to download PDF");
    } finally {
      setDownloadingPdf(false);
    }
  };

  // ============================================================
  // HR RELEASE FLOW
  //
  // Review & Release
  //      ↓
  // Release Checklist
  //      ↓
  // Answer every Yes/No
  //      ↓
  // All Yes
  //      ↓
  // Generate
  //      ↓
  // Offer Letter Preview
  //      ↓
  // Release to Candidate
  // ============================================================
  const handleHRRelease = (offer) => {
    if (!offer) {
      toast.error("Offer information is missing");
      return;
    }

    const offerId = offer.offer_id || offer.id;

    if (!offerId) {
      toast.error("Offer ID is missing");
      return;
    }

    setReleaseChecklistOffer({
      ...offer,
      offer_id: offerId,
    });

    setShowReleaseChecklist(true);
  };

  const generatePreviewHtmlForReleaseOffer = async (offer) => {
    const offerId = offer?.offer_id || offer?.id;

    if (!offerId) {
      throw new Error("Offer ID is missing");
    }

    const response = await offersAPI.getById(offerId);
    const fullOffer = response.data || offer;

    const candidateName =
      fullOffer.candidate_name ||
      `${fullOffer.custom_first_name || ""} ${fullOffer.custom_last_name || ""}`.trim();

    const location =
      fullOffer.location_offered ||
      fullOffer.location ||
      "";

    const role =
      fullOffer.position_offered ||
      fullOffer.position ||
      "";

    if (!candidateName) {
      throw new Error("Candidate name is missing");
    }

    if (!location) {
      throw new Error("Offered location is missing");
    }

    if (!role) {
      throw new Error("Position is missing");
    }

    const company =
      fullOffer.company ||
      (String(fullOffer.offered_company || "").toLowerCase().includes("eldaas")
        ? "eldaas"
        : "uss");

    const templateType =
      fullOffer.template_type ||
      fullOffer.templateType ||
      (company === "eldaas" ? "regular" : "without_agreement");

    const isServiceAgreement =
      (company === "uss" && templateType === "with_agreement") ||
      (company === "eldaas" && templateType === "service_agg");

    const body = {
      name: candidateName,
      location,
      role,
      date:
        fullOffer.offer_date ||
        fullOffer.date ||
        new Date().toISOString().split("T")[0],
      templateType,
      company,
      hrDate: "",
      salutation: fullOffer.salutation || "",
      offerType: fullOffer.offer_type || "regular",
      joiningBonus: fullOffer.joining_bonus || "No",
      joiningBonusAmount: fullOffer.joining_bonus_amount || "",
      retentionBonus: fullOffer.retention_bonus || "No",
      retentionBonusAmount: fullOffer.retention_total || "",
      bond_period: isServiceAgreement
        ? fullOffer.bond_period_service || fullOffer.training_period || ""
        : "",
      bond_clause: !isServiceAgreement
        ? fullOffer.bond_period || ""
        : "",
      bond_amount: isServiceAgreement
        ? fullOffer.bond_amount || ""
        : "",
    };

    if (company === "uss" && templateType === "with_agreement") {
      body.stipend =
        fullOffer.stipend ||
        fullOffer.internship_stipend ||
        fullOffer.training_amount ||
        "";

      body.years = [
        {
          fixed: fullOffer.year1_fixed || "",
          variable: fullOffer.year1_variable_amount || "",
        },
        {
          fixed: fullOffer.year2_fixed || "",
          variable: fullOffer.year2_variable_amount || "",
        },
        {
          fixed: fullOffer.year3_fixed || "",
          variable: fullOffer.year3_variable_amount || "",
        },
        {
          fixed: fullOffer.year4_fixed || "",
          variable: fullOffer.year4_variable_amount || "",
        },
      ];

      body.start_date =
        fullOffer.start_date ||
        fullOffer.expected_doj ||
        "";
    } else if (
      company === "uss" &&
      templateType === "without_agreement"
    ) {
      body.fixedCTC =
        fullOffer.offered_ctc_fixed ||
        fullOffer.fixedCTC ||
        "";

      body.variableAmount =
        fullOffer.offered_ctc_variable_amount ?? "";

      body.variableType = fullOffer.offered_ctc_variable || "";

      body.annualVariablePay =
        fullOffer.variable_annual_pay_amount || "";

      body.annualRetentionBonus =
        fullOffer.variable_retention_bonus_amount || "";

      body.start_date =
        fullOffer.start_date ||
        fullOffer.expected_doj ||
        "";
    } else if (company === "eldaas") {
      body.fixedSalary =
        fullOffer.offered_ctc_fixed ||
        fullOffer.fixedSalary ||
        "";

      body.variableSalary =
        fullOffer.offered_ctc_variable_amount ?? "";

      body.variableType = fullOffer.offered_ctc_variable || "";

      body.annualVariablePay =
        fullOffer.variable_annual_pay_amount || "";

      body.annualRetentionBonus =
        fullOffer.variable_retention_bonus_amount || "";

      body.start_date =
        fullOffer.start_date ||
        fullOffer.expected_doj ||
        "";
    }

    const previewResponse =
      await offerLetterAPI.generatePreview(body);

    return {
      html: previewResponse.data?.html || "",
      offer: fullOffer,
    };
  };

  const handleGenerateReleaseOffer = async (offer) => {
    if (!offer) {
      toast.error("Offer information is missing");
      return;
    }

    try {
      setGeneratingPreview(true);

      const result =
        await generatePreviewHtmlForReleaseOffer(offer);

      if (!result.html) {
        throw new Error("Offer letter generation returned empty content");
      }

      setOfferPreviewHtml(result.html);
      setHrReleaseOffer({
        ...result.offer,
        offer_id: result.offer.offer_id || result.offer.id,
      });

      setShowReleaseChecklist(false);
      setReleaseChecklistOffer(null);
      setShowOfferPreviewModal(true);

      toast.success("Offer letter generated successfully");
    } catch (error) {
      console.error("HR offer generation error:", error);

      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to generate offer letter"
      );
    } finally {
      setGeneratingPreview(false);
    }
  };

  const handleReleaseGeneratedOffer = () => {
    const offerId =
      hrReleaseOffer?.offer_id ||
      hrReleaseOffer?.id;

    if (!offerId) {
      toast.error("Offer ID is missing");
      return;
    }

    if (!offerPreviewHtml) {
      toast.error("Generate the offer letter before releasing it");
      return;
    }

    setConfirmReleaseGenerated(true);
  };

  const doReleaseGeneratedOffer = async () => {
    const offerId =
      hrReleaseOffer?.offer_id ||
      hrReleaseOffer?.id;

    if (!offerId) {
      toast.error("Offer ID is missing");
      setConfirmReleaseGenerated(false);
      return;
    }

    try {
      setReleasingGeneratedOffer(true);

      let offerLetterUrl = null;
      try {
        const pdfRes = await offerLetterAPI.downloadPdf(offerPreviewHtml);
        const safeName = (
          hrReleaseOffer?.candidate_name || "offer_letter"
        )
          .replace(/[^a-z0-9]/gi, "_")
          .toLowerCase();
        const pdfFile = new File(
          [pdfRes.data],
          `offer_letter_${safeName}.pdf`,
          { type: "application/pdf" }
        );
        const uploadRes = await offersAPI.uploadDocument(
          offerId,
          "offer_letter",
          pdfFile
        );
        offerLetterUrl = uploadRes.data?.url || uploadRes.data?.downloadUrl || null;
      } catch (pdfErr) {
        console.error("Offer letter S3 upload error:", pdfErr);
      }

      await offersAPI.releaseToCandidate(offerId);

      toast.success(
        offerLetterUrl
          ? "Offer letter uploaded & released to candidate"
          : "Offer released to candidate (offer letter upload failed)"
      );

      setShowOfferPreviewModal(false);
      setHrReleaseOffer(null);
      setOfferPreviewHtml("");

      await fetchOffers();
    } catch (error) {
      console.error("HR generated offer release error:", error);

      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to release offer"
      );
    } finally {
      setReleasingGeneratedOffer(false);
      setConfirmReleaseGenerated(false);
    }
  };

  const openDetailsModal = async (offer) => {
    try {
      if (offer.offer_id) {
        const res = await offersAPI.getById(offer.offer_id);
        setSelectedDetails(res.data);
      } else {
        setSelectedDetails(offer);
      }
      setShowDetailsModal(true);
    } catch {
      toast.error("Failed to load offer details");
    }
  };

  
  
  
  
  
  const getApproverName = (stage, offer) => {
  if (!offer) return "";

  if (stage === "Stage1") {
    return (
      offer.hiring_manager_name ||
      offer.stage1_email ||
      ""
    );
  }

  if (stage === "Stage2") {
    return (
      offer.stage2_name ||
      offer.stage2_email ||
      ""
    );
  }

  if (stage === "Stage3") {
    return (
      offer.stage3_name ||
      offer.stage3_email ||
      ""
    );
  }

  return "";
};

  const renderStatusBadge = (status) => {
    const cls = status?.toLowerCase().replace(/\s+/g, "-") || "draft";
    return <span className={`offer-status-badge ${cls}`}>{status || "Draft"}</span>;
  };

  const renderDelegationBadge = (offer, stageNum) => {
    if (!offer) return null;

    // Delegated-from info returned by backend (workflow_delegations)
    if (stageNum) {
      const fromEmail = offer[`delegated_from_stage${stageNum}`];
      if (fromEmail) {
        return (
          <span className="del-indicator" title={`Delegated from: ${fromEmail}`}>
            Delegated from {fromEmail}
          </span>
        );
      }
    } else {
      const cs = Number(offer.current_stage);
      const fromEmail =
        (cs >= 1 && cs <= 3 && offer[`delegated_from_stage${cs}`]) ||
        offer.delegated_from_stage1 ||
        offer.delegated_from_stage2 ||
        offer.delegated_from_stage3;
      if (fromEmail) {
        return (
          <span className="del-indicator" title={`Delegated from: ${fromEmail}`}>
            Delegated from {fromEmail}
          </span>
        );
      }
    }

    const delegationField = offer.delegation_info;
    if (delegationField && (!stageNum || delegationField.stage === stageNum || delegationField.stage === 0)) {
      return (
        <span className="del-indicator" title={`Delegated from: ${delegationField.delegator_name || delegationField.delegator_email}`}>
          Delegated from {delegationField.delegator_name || delegationField.delegator_email}
        </span>
      );
    }
    const legacyField = offer.delegated_from_name || offer.delegated_from;
    if (legacyField && (!stageNum || stageNum === 1)) {
      return (
        <span className="del-indicator" title={`Delegated from: ${legacyField}`}>
          Delegated from {legacyField}
        </span>
      );
    }
    return null;
  };

  const getLatestRejectionRemark = (offer) => {
    if (!offer?.approval_remarks) return null;

    // ============================================================
    // ONLY WHILE THE OFFER IS ACTUALLY RETURNED
    // approval_remarks keeps every reject entry forever. Once the
    // returned offer is corrected and resubmitted, the backend moves
    // offer_status back to "Pending Approval", so the old reject is
    // history — showing it again on the next stage (e.g. S2 -> S3)
    // reads as a fresh send-back. While it sits with the sender the
    // status is still "Sent Back", so the note correctly reappears.
    // ============================================================
    if (
      String(offer?.offer_status || "").trim().toLowerCase() !==
      "sent back"
    ) {
      return null;
    }

    try {
      const remarks =
        typeof offer.approval_remarks === "string"
          ? JSON.parse(offer.approval_remarks)
          : offer.approval_remarks;

      if (!Array.isArray(remarks)) return null;

      const rejection = [...remarks]
        .reverse()
        .find(
          (entry) =>
            String(entry?.action || "").toLowerCase() === "reject"
        );

      return rejection || null;
    } catch (error) {
      console.error("Failed to parse approval_remarks:", error);
      return null;
    }
  };

  // Banner shown inside the edit modal when any stage has been rejected.
  const renderEditRejectionBanner = () => {
    if (!editingOffer) return null;

    const isRejected =
      editingOffer.stage1_status === "Rejected" ||
      editingOffer.stage2_status === "Rejected" ||
      editingOffer.stage3_status === "Rejected";

    if (!isRejected) return null;

    const rejectRemark = getLatestRejectionRemark(editingOffer);
    const rejectReasonText = (rejectRemark?.reason || rejectRemark?.remarks || "").trim();
    const rejectBy = rejectRemark?.by_name || rejectRemark?.by || "";

    return (
      <>
        <strong>✖ Rejected</strong>
        {rejectBy ? (
          <div className="edit-modal-rejection-by">
            Rejected by: {rejectBy}
          </div>
        ) : null}
        <div className="edit-modal-rejection-reason">
          Reason:
          <span className="status-rejected-reason-text">
            {rejectReasonText ? `"${rejectReasonText}"` : '"nothing mentioned"'}
          </span>
        </div>
      </>
    );
  };

  const getApproverEmail = (stage, offer) => {
    if (!offer) return "";
    if (stage === "Stage1") return offer.stage1_email || "";
    if (stage === "Stage2") return offer.stage2_email || "";
    if (stage === "Stage3") return offer.stage3_email || "";
    return "";
  };

  // "Sent back by X (Stage N) — reason" note for the actionable pending row
  const renderRejectionNote = (offer) => {
    const rej = getLatestRejectionRemark(offer);
    if (!rej) return null;
    return (
      <div className="pending-reject-note">
        <strong>
          ↩ Sent back from Stage {rej.stage} by {rej.by_name || rej.by}
        </strong>
        {rej.reason ? (
          <span className="pending-reject-reason">"{rej.reason}"</span>
        ) : null}
      </div>
    );
  };

  // "Delegated workflow rejected" warning for the delegator's assigned-away board
  const renderDelegatedRejectedNote = (offer) => {
    const rej = getLatestRejectionRemark(offer);
    if (!rej) return null;
    return (
      <span className="delegated-reject-note">
        ⚠ Delegated workflow rejected
        {rej.by_name || rej.by ? ` — returned by ${rej.by_name || rej.by}` : ""}
        {rej.stage ? ` (Stage ${rej.stage})` : ""}
        {rej.reason ? (
          <em className="delegated-reject-reason"> "{rej.reason}"</em>
        ) : null}
      </span>
    );
  };

  const getAnnualCTC = (fixed, variableType, variableAmount) => {

    const fixedSalary = Number(fixed) || 0;

    const amount = Number(variableAmount) || 0;

    let annualVariable = 0;

    switch(variableType){

        case "Monthly Bonus":
            annualVariable = amount * 12;
            break;

        case "Quarterly Bonus":
            annualVariable = amount * 4;
            break;

        case "Half Yearly Bonus":
            annualVariable = amount * 2;
            break;

        case "Yearly Bonus":
            annualVariable = amount;
            break;

        default:
            annualVariable = 0;

    }

    return fixedSalary + annualVariable;

};

const loadConditionalMaster = async () => {

    try{

        const res = await offerMasterAPI.getConditionalOfferMaster();

        if(!res.data) return;

        setOfferLetterForm(prev => ({

            ...prev,

            training_amount: res.data.training_amount,

            internship_period: res.data.internship_period,
            internship_stipend: res.data.internship_stipend,

            year1_fixed: res.data.year1_fixed,
            year1_variable_type: res.data.year1_variable_type,
            year1_variable_amount: res.data.year1_variable_amount,
            year1_ctc: res.data.year1_ctc,

            year2_fixed: res.data.year2_fixed,
            year2_variable_type: res.data.year2_variable_type,
            year2_variable_amount: res.data.year2_variable_amount,
            year2_ctc: res.data.year2_ctc,

            year3_fixed: res.data.year3_fixed,
            year3_variable_type: res.data.year3_variable_type,
            year3_variable_amount: res.data.year3_variable_amount,
            year3_ctc: res.data.year3_ctc,

            year4_fixed: res.data.year4_fixed,
            year4_variable_type: res.data.year4_variable_type,
            year4_variable_amount: res.data.year4_variable_amount,
            year4_ctc: res.data.year4_ctc

        }));

    }

    catch(err){

        console.log(err);

    }

};

const handleApproveOffer = async (offerId, offer = null) => {
  try {

    setLoading(true);

    const response =
      await offersAPI.approve(offerId);

    toast.success(
      response.data?.message ||
      "Offer approved successfully"
    );

    const delegatedFrom = getDelegatedFromForOffer(offer);
    if (delegatedFrom) {
      toast.info(
        `Delegated task: Stage ${offer.current_stage} approved on behalf of ${delegatedFrom}`
      );
    }

    
    await fetchOffers();

  } catch (error) {
  // console.error("Approve Offer Error:", error);

  // console.error(
  //   "Backend Response:",
  //   error.response?.data
  // );

  // console.error(
  //   "Backend Status:",
  //   error.response?.status
  // );

  toast.error(
    error.response?.data?.error ||
    "Failed to approve offer"
  );
}
};

const handleRejectOffer = async (offerId) => {
  try {

    setLoading(true);

    const response =
      await offersAPI.reject(offerId);

    toast.success(
      response.data?.message ||
      "Offer rejected successfully"
    );

    await fetchOffers();

  } catch (error) {

    console.error(
      "Reject Offer Error:",
      error
    );

    toast.error(
      error.response?.data?.error ||
      "Failed to reject offer"
    );

  } finally {

    setLoading(false);

  }
};

  return (
    <div className="offers-container">
      <div className="offers-card">
        <div className="offers-header-top">
          <h2>Offer Workflow Management</h2>

          {isTA && canOpenStage1Delegation() && (
            <button
              type="button"
              className="stage1-top-delegation-button"
              onClick={() => {
                const offer = visibleOffers.find(
                  (o) =>
                    Number(o.current_stage) === 1 &&
                    String(o.stage1_status || "")
                      .trim()
                      .toLowerCase() === "pending"
                );
                if (offer) {
                  setDelegateOffer(offer);
                  setDelegateStage(1);
                  setShowDelegateModal(true);
                }
              }}
              title="Delegate pending Stage 1 approvals"
            >
              Delegate Stage 1
            </button>
          )}

          {canOpenStage2Delegation() && (
            <button
              type="button"
              className="stage-delegate-top-btn stage2"
              onClick={() => {
                const offer = visibleOffers.find(
                  (o) => Number(o.current_stage) === 2 && String(o.stage2_status || "").toLowerCase() === "pending"
                );
                if (offer) {
                  setDelegateOffer(offer);
                  setDelegateStage(2);
                  setShowDelegateModal(true);
                }
              }}
              title="Delegate pending Stage 2 approvals"
            >
              Delegate Stage 2
            </button>
          )}

          {canOpenStage3Delegation() && (
            <button
              type="button"
              className="stage-delegate-top-btn stage3"
              onClick={() => {
                const offer = visibleOffers.find(
                  (o) => Number(o.current_stage) === 3 && String(o.stage3_status || "").toLowerCase() === "pending"
                );
                if (offer) {
                  setDelegateOffer(offer);
                  setDelegateStage(3);
                  setShowDelegateModal(true);
                }
              }}
              title="Delegate pending Stage 3 approvals"
            >
              Delegate Stage 3
            </button>
          )}

        {hasRole(userRole, ["super_admin"]) && (
                <button
                  type="button"
                  className="manage-workflow-button"
                  onClick={() => navigate("/admin/workflow-master")}
                >
                  Manage Workflow Approvers
                </button>
              )}
        </div>

        {}

            <div className="offers-tabs">

              <button
                className={activeTab === "workflow" ? "active" : ""}
                onClick={() => setActiveTab("workflow")}
              >
                Workflow
              </button>

              <button
                className={activeTab === "pending" ? "active pending-tab" : ""}
                onClick={() => setActiveTab("pending")}
              >
                My Pending Tasks
              </button>

              <button
                className={activeTab === "accepted" ? "active" : ""}
                onClick={() => setActiveTab("accepted")}
              >
                You Accepted
              </button>

            </div>


           {activeTab === "pending" && (

  <div className="pending-tasks-container">

    <div className="pending-tasks-header">
      <div>
        <h3>My Pending Tasks</h3>
        <p>Offers waiting for your approval</p>
      </div>

      <span className="pending-count">
        {offers.length} Pending
      </span>
    </div>


    {offers.length === 0 ? (

      <div className="no-pending-tasks">
        <h4>No Pending Tasks</h4>
        <p>
          You don't have any offers waiting for approval.
        </p>
      </div>

    ) : (() => {

      const actionableOffers = offers.filter(
        (o) => !getDelegatedAwayForOffer(o)
      );
      const alreadyAssignedOffers = offers.filter(
        (o) => getDelegatedAwayForOffer(o)
      );

      return (
      <>

      {actionableOffers.length > 0 && (
      <div className="pending-table-wrapper">

        <table className="offers-table pending-table">

          <thead>
            <tr>
              <th scope="col">CANDIDATE</th>
              <th scope="col">EMAIL</th>
              <th scope="col">POSITION</th>
              <th scope="col">TOTAL CTC</th>
              <th scope="col">BUSINESS UNIT</th>
              <th scope="col">DEPARTMENT</th>
              <th scope="col">STAGE</th>
              <th scope="col">ACTION</th>
            </tr>
          </thead>


          <tbody>

           {actionableOffers.map((offer) => (

              <tr key={offer.offer_id || offer.id}>

                {/* Candidate */}
                <td>
                  <strong>
                    {offer.candidate_name || "-"}
                  </strong>
                  {renderDelegationBadge(offer)}
                </td>


                {/* Email */}
                <td>
                  {getOfferEmail(offer)}
                </td>


                {/* Position */}
                <td>
                  {offer.position_offered ||
                    offer.position ||
                    "-"}
                </td>


                {/* Total CTC (E + F of Annexure-A) */}
                <td className="offer-ctc-cell">
                  {renderOfferCtcCell(offer)}
                </td>


                {/* Business Unit */}
                <td>
                  {offer.business_unit || "-"}
                </td>


                {/* Department */}
                <td>
                  {offer.department || "-"}
                </td>


                {/* Current Stage */}
               <td>
                  <span className="pending-stage">
                    {Number(offer.current_stage) === 1
                      ? "1 - Hiring Manager"
                      : Number(offer.current_stage) === 2
                      ? "2 - Business Unit Head"
                      : Number(offer.current_stage) === 3
                      ? "3 - Final Approval"
                      : "-"}
                  </span>
                </td>


                {/* ACTION */}
               <td>
  {renderRejectionNote(offer)}
  <div className="pending-action-buttons">

    <button
      type="button"
      className="action-view"
      onClick={() => openDetailsModal(offer)}
    >
      View
    </button>

    {canEditOffer(offer) && (
      <button
        type="button"
        className="edit-btn"
        onClick={() =>
          openEditOfferModal(
            offer.offer_id || offer.id
          )
        }
      >
        Edit
      </button>
    )}

    {offer.current_stage &&
          Number(offer.current_stage) >= 1 &&
          Number(offer.current_stage) <= 3 &&

          (
            (
              Number(offer.current_stage) === 1 &&
              offer.stage1_status === "Pending"
            ) ||
            (
              Number(offer.current_stage) === 2 &&
              offer.stage2_status === "Pending"
            ) ||
            (
              Number(offer.current_stage) === 3 &&
              offer.stage3_status === "Pending"
            )
          ) && (

            <button
              type="button"
              className="btn-reject"
              onClick={() =>
                handleOpenRejectModal(
                  offer
                )
              }
            >
              Reject
            </button>

          )}

    <button
      type="button"
      className="action-approve"
      onClick={() =>
        handleApproveOffer(
          offer.offer_id || offer.id,
          offer
        )
      }
    >
      Approve
    </button>

  </div>
</td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>
      )}

      {alreadyAssignedOffers.length > 0 && (
      <div className="pending-table-wrapper delegated-away-wrapper">

        <div className="delegated-away-header">
          <h4 className="delegated-away-title">Already Assigned (Delegated to Others)</h4>
          <span className="delegated-away-sub">You have passed these tasks to someone else and no longer need to act on them.</span>
        </div>

        <table className="offers-table pending-table delegated-away-table">

          <thead>
            <tr>
              <th scope="col">CANDIDATE</th>
              <th scope="col">EMAIL</th>
              <th scope="col">POSITION</th>
              <th scope="col">BUSINESS UNIT</th>
              <th scope="col">DEPARTMENT</th>
              <th scope="col">STAGE</th>
              <th scope="col">ASSIGNED TO</th>
            </tr>
          </thead>

          <tbody>

           {alreadyAssignedOffers.map((offer) => {
             const cs = Number(offer.current_stage);
             const delgEmail = offer[`delegated_to_stage${cs}`];
             const delgName = offer[`delegated_to_stage${cs}_name`];
             return (
              <tr key={offer.offer_id || offer.id} className="delegated-away-row">

                <td>
                  <strong>{offer.candidate_name || "-"}</strong>
                </td>

                <td>{getOfferEmail(offer)}</td>

                <td>{offer.position_offered || offer.position || "-"}</td>

                <td>{offer.business_unit || "-"}</td>

                <td>{offer.department || "-"}</td>

                <td>
                  <span className="pending-stage">
                    {Number(offer.current_stage) === 1
                      ? "1 - Hiring Manager"
                      : Number(offer.current_stage) === 2
                      ? "2 - Business Unit Head"
                      : Number(offer.current_stage) === 3
                      ? "3 - Final Approval"
                      : "-"}
                  </span>
                </td>

                <td>
                  <div className="already-assigned-cell">
                    <span className="already-assigned-note">
                      Already assigned to{" "}
                      <strong>{delgName || delgEmail}</strong>
                      {delgName && delgEmail && delgName !== delgEmail
                        ? ` (${delgEmail})`
                        : ""}
                    </span>
                    {renderDelegatedRejectedNote(offer)}
                  </div>
                </td>

              </tr>
             );
           })}

          </tbody>

        </table>

      </div>
      )}

      </>
      );
    })()}

  </div>

)}
{activeTab !== "pending" && (
  <>
        {loading ? (
          <TableSkeleton rows={5} cols={8} />
        ) : (
          <div className="table-wrapper">
          <table className="offers-table">
            <thead>
              <tr>
                <th scope="col">Candidate</th>
                <th scope="col">Email</th>
                <th scope="col">Position</th>
                <th scope="col">Total CTC</th>
                <th scope="col">Status</th>
                <th scope="col">Stage 1</th>
                <th scope="col">Stage 2</th>
                <th scope="col">Stage 3</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (offers.length === 0) {
                  return (
                    <tr>
                      <td colSpan="9" className="no-data">
                        <EmptyState
                          icon={<DescriptionOutlinedIcon style={{ fontSize: 48, color: "#94A3B8" }} />}
                          title="No offers found"
                          message="Please add resumes and start the offer workflow to see candidates here."
                        />
                      </td>
                    </tr>
                  );
                }

                return visibleOffers.map((offer) => (
                  <tr key={offer.offer_id || offer.candidate_id}>
                    <td>
                      <span className="candidate-name-link" onClick={() => openDetailsModal(offer)}>
                        {offer.candidate_name || `${offer.custom_first_name || ""} ${offer.custom_last_name || ""}`}
                      </span>
                    </td>
                    <td>{getOfferEmail(offer)}</td>
                    <td>{offer.position_offered || offer.position}</td>
                    <td className="offer-ctc-cell">{renderOfferCtcCell(offer)}</td>
                    <td>{renderStatusBadge(offer.offer_status || offer.overall_status)}</td>
                    <td>
                          <div
                            className="stage-name"
                            title={[
                              getApproverEmail("Stage1", offer) &&
                                `Assigned: ${getApproverEmail("Stage1", offer)}`,
                              offer.stage1_approved_by &&
                                `Approved by: ${offer.stage1_approved_by}`,
                            ]
                              .filter(Boolean)
                              .join(" | ")}
                          >
                            {getApproverName("Stage1", offer) || "-"}
                            {renderDelegationBadge(offer, 1)}
                          </div>

                          {offer.stage1_status === "Approved" && (
                            <span className="status-approved">
                              ✔ Approved
                            </span>
                          )}

                          {offer.stage1_status === "Rejected" && (
                            <>
                              <span className="status-rejected">
                                ✖ Rejected
                              </span>
                              {(() => {
                                const rej = getLatestRejectionRemark(offer);
                                const rejReason = rej?.reason || rej?.remarks;
                                return (
                                  <div className="status-rejected-reason">
                                    Reason:{" "}
                                    <span className="status-rejected-reason-text">
                                      "{rejReason ? rejReason.trim() : "nothing mentioned"}"
                                    </span>
                                  </div>
                                );
                              })()}
                            </>
                          )}

                          {offer.stage1_status === "Sent Back" && (
                            <span className="status-sentback">
                              ↩ Sent Back
                            </span>
                          )}

                          {offer.stage1_status === "Pending" && (
                            <>
                              <span className="status-pending">
                                Pending
                              </span>

                              <div className="stage-waiting">
                                Waiting for{" "}
                                {getApproverName("Stage1", offer) || "Hiring Manager"}
                              </div>
                            </>
                          )}

                          {(!offer.stage1_status ||
                            offer.stage1_status === "-") && (
                            <span className="status-not-started">
                              Not Started
                            </span>
                          )}
                        </td>
                    <td>
                      <div
                        className="stage-name"
                        title={[
                          getApproverEmail("Stage2", offer) &&
                            `Assigned: ${getApproverEmail("Stage2", offer)}`,
                          offer.stage2_approved_by &&
                            `Approved by: ${offer.stage2_approved_by}`,
                        ]
                          .filter(Boolean)
                          .join(" | ")}
                      >
                        {getApproverName("Stage2", offer) || "-"}
                        {renderDelegationBadge(offer, 2)}
                      </div>
                      {offer.stage2_status === "Approved" && <span className="status-approved">✔ Approved</span>}
                      {offer.stage2_status === "Rejected" && <span className="status-rejected">✖ Rejected</span>}
                      {offer.stage2_status === "Sent Back" && <span className="status-sentback">↩ Sent Back</span>}
                      {offer.stage2_status === "Pending" && (
                          <span className="status-pending">Pending</span>
                        )}

                        {offer.stage2_status === "Pending" &&
                          String(offer?.stage2_email || "")
                            .trim()
                            .toLowerCase() === normalizedUserEmail && (
                          <button
                            type="button"
                            className="stage-delegate-btn"
                            onClick={() => {
                              setDelegateOffer(offer);
                              setDelegateStage(2);
                              setShowDelegateModal(true);
                            }}
                            title="Delegate this Stage 2 approval"
                          >
                            Delegate
                          </button>
                        )}

                        {(!offer.stage2_status || offer.stage2_status === "-") && (
                          <span className="status-not-started">Not Started</span>
                        )}
                    </td>
                    <td>
                      <div
                        className="stage-name"
                        title={[
                          getApproverEmail("Stage3", offer) &&
                            `Assigned: ${getApproverEmail("Stage3", offer)}`,
                          offer.stage3_approved_by &&
                            `Approved by: ${offer.stage3_approved_by}`,
                        ]
                          .filter(Boolean)
                          .join(" | ")}
                      >
                        {getApproverName("Stage3", offer) || "-"}
                        {renderDelegationBadge(offer, 3)}
                      </div>
                      {offer.stage3_status === "Approved" && <span className="status-approved">✔ Approved</span>}
                      {offer.stage3_status === "Rejected" && <span className="status-rejected">✖ Rejected</span>}
                      {offer.stage3_status === "Sent Back" && <span className="status-sentback">↩ Sent Back</span>}
                      {offer.stage3_status === "Pending" && (
                          <span className="status-pending">Pending</span>
                        )}

                        {offer.stage3_status === "Pending" &&
                          String(offer?.stage3_email || "")
                            .trim()
                            .toLowerCase() === normalizedUserEmail && (
                          <button
                            type="button"
                            className="stage-delegate-btn"
                            onClick={() => {
                              setDelegateOffer(offer);
                              setDelegateStage(3);
                              setShowDelegateModal(true);
                            }}
                            title="Delegate this Stage 3 approval"
                          >
                            Delegate
                          </button>
                        )}

                        {(!offer.stage3_status || offer.stage3_status === "-") && (
                          <span className="status-not-started">Not Started</span>
                        )}
                    </td>
                    <td>
  <div className="action-buttons">

    <button
      type="button"
      className="action-view"
      onClick={() => openDetailsModal(offer)}
    >
      View
    </button>

    {(() => {
      const accepted = Number(offer.offer_accepted) === 1;
      const rejected = Number(offer.offer_rejected) === 1;

      if (accepted) {
        return (
          <span className="offer-accepted">
            ✔ Candidate Accepted Offer
          </span>
        );
      }

      if (rejected) {
        return (
          <span className="offer-rejected">
            ✖ Candidate Rejected Offer
          </span>
        );
      }

      return (
        <>
          {/* =========================
              OTHER WORKFLOW ACTIONS
          ========================= */}

          {canReleaseOffer(offer) && (
            <button
              type="button"
              className="release-btn"
              onClick={() =>
                handleHRRelease(offer)
              }
            >
              Review & Release
            </button>
          )}

          {offer.overall_status === "Approved" &&
            isOfferLetterSender(offer) && (
              <button
                type="button"
                className="assign-btn"
                onClick={() =>
                  openOfferLetterPopup(offer)
                }
              >
                Send Offer Letter
              </button>
          )}

          {isHR &&
            canAssignStage(offer) &&
            offer.overall_status !== "Approved" && (
              <button
                type="button"
                className="assign-btn"
                onClick={() =>
                  openMailPopup(offer)
                }
              >
                Assign Stage
              </button>
          )}

          {offer.offer_status === "Draft" ? (
            /* A draft has one action: reopen it in the Create Offer modal,
               filled in exactly as it was left. */
            canEditOffer(offer) && (
              <button
                type="button"
                className="edit-btn"
                onClick={() => openDraftOfferModal(offer.offer_id || offer.id)}
              >
                Edit
              </button>
            )
          ) : (
            canEditOffer(offer) && (
              <button
                type="button"
                className="edit-btn"
                onClick={() =>
                  openEditOfferModal(offer.offer_id || offer.id)
                }
              >
                Edit
              </button>
            )
          )}

          {/* =========================
              REMOVE BUTTON
          ========================= */}

          {hasRole(userRole, ["super_admin"]) && (
            <button
              type="button"
              className="remove-btn"
              onClick={() =>
                handleRemove(
                  offer.offer_id
                )
              }
            >
              Delete
            </button>
          )}

        </>
      );
    })()}

  </div>
</td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
          </div>
        )}
            </>
)}

        {!loading && activeTab === "workflow" && (
          <div className="create-offer-section">
            
           {(mayPerform("offer", "create") || mayPerform("offer", "manage")) && (
            <button type="button" className="create-offer-btn" onClick={openCreateOfferModal}>
              
              Create Offer
            </button>
          
            )}
          </div>
        )}
        
      </div>

      {/* ================= MAIL MODAL ================= */}
      {showMailModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>
              {selectedOffer?.overall_status === "Approved" || selectedOffer?.offer_status === "Ready for HR Release"
                ? "Send Offer Letter"
                : "Assign Workflow Stage"}
            </h3>
            <label>To</label>
            {selectedOffer?.overall_status === "Approved" || selectedOffer?.offer_status === "Ready for HR Release" ? (
              <input
                type="email"
                placeholder="Enter candidate email"
                value={mailData.to}
                onChange={(e) => setMailData({ ...mailData, to: e.target.value })}
              />
            ) : (
              <select
                value={mailData.to}
                onChange={(e) => setMailData({ ...mailData, to: e.target.value })}
              >
                <option value="">Select Approver</option>
                {selectedOffer?.stage1_status !== "Approved" &&
                  selectedOffer?.stage1_email && (
                    <option value={selectedOffer.stage1_email}>
                      {selectedOffer.stage1_email}
                    </option>
                  )}
                {selectedOffer?.stage1_status === "Approved" &&
                  selectedOffer?.stage2_email && (
                    <option value={selectedOffer.stage2_email}>
                      {selectedOffer.stage2_email}
                    </option>
                  )}
                {selectedOffer?.stage2_status === "Approved" &&
                  selectedOffer?.stage3_email && (
                    <option value={selectedOffer.stage3_email}>
                      {selectedOffer.stage3_email}
                    </option>
                  )}
              </select>
            )}
            <label>CC</label>
            <input
              placeholder="Enter CC emails"
              value={mailData.cc}
              onChange={(e) => setMailData({ ...mailData, cc: e.target.value })}
            />
            <label>Subject</label>
            <input
              value={mailData.subject}
              onChange={(e) => setMailData({ ...mailData, subject: e.target.value })}
            />
            <label>Body</label>
            <textarea
              rows="6"
              value={mailData.body}
              onChange={(e) => setMailData({ ...mailData, body: e.target.value })}
            />
            <label>Attachment</label>
            <input
              type="file"
              onChange={(e) => setMailData({ ...mailData, file: e.target.files[0] })}
            />
            {mailData.file && <p className="attachment-hint">Attached: {mailData.file.name}</p>}
            <div className="modal-actions">
              <LoadingButton className="primary-btn" onClick={sendWorkflowMail} loading={sendingMail} loadingText="Sending...">
                Send Mail
              </LoadingButton>
              <button className="secondary-btn" onClick={() => setShowMailModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

    

      {/* ================= CREATE OFFER LETTER MODAL ================= */}
      {showCreateOfferModal && (
        <div className="modal-overlay">
          <div className="modal-content create-offer-modal-wide">
            <h3>Create Offer</h3>

            <form onSubmit={handleCreateOffer}>
              <div className="form-section">
                <h4>Candidate Information</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Candidate Name<span className="required-asterisk">*</span></label>
                    <div className="candidate-autocomplete">
                      <input
                        type="text" placeholder="Search Candidate" value={offerLetterForm.candidate_name}
                        onChange={(e) => { setOfferLetterForm({ ...offerLetterForm, candidate_name: e.target.value }); setShowCandidateSuggestions(true); }}
                        onFocus={() => setShowCandidateSuggestions(true)} autoComplete="off"
                      />
                      {showCandidateSuggestions && filteredCandidateSuggestions.length > 0 && (
                        <ul className="candidate-suggestions">
                          {filteredCandidateSuggestions.slice(0, 8).map((candidate) => (
                            <li key={candidate.id}>
                              <button type="button" onClick={() => selectCandidateForOffer(candidate)}>
                                {getCandidateDisplayName(candidate)}
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Position Offered<span className="required-asterisk">*</span></label>
                    <input placeholder="Position" value={offerLetterForm.position_offered} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, position_offered: e.target.value, role: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Salutation</label>
                    <select value={offerLetterForm.salutation} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, salutation: e.target.value })}>
                      <option value="">Select</option>
                      <option value="Mr.">Mr.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Mrs.">Mrs.</option>
                      <option value="Dr.">Dr.</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Experience<span className="required-asterisk">*</span></label>
                    <input placeholder="e.g. 5 Years, 3 Years 2 Months" value={offerLetterForm.experience} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, experience: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Relevant Experience</label>
                    <input placeholder="e.g. 3 years" value={offerLetterForm.relevant_experience} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, relevant_experience: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Grade</label>
                    <select placeholder="e.g. L1, L2" value={offerLetterForm.grade} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, grade: e.target.value })} >
                     <option value="">Select</option>
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          </select>
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <input placeholder="Address" type="text" value={offerLetterForm.address} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, address: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Notice Period</label>
                    <input placeholder="No of days Notice.." type = "Text" value={offerLetterForm.notice_period} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, notice_period: e.target.value })} />
                  </div>
                  <div className="form-group">
                      <label>Hiring Manager</label>

                      <input
                        type="text"
                        value={offerLetterForm.hiring_manager_name}
                        readOnly
                      />
                    </div>

                     <div className="form-group">
                      <label>Hiring Manager Email</label>

                      <input
                        type="text"
                        value={offerLetterForm.hiring_manager_email}
                        readOnly
                      />
                    </div>
                  <div className="form-row">
                  </div>
                </div>
              </div>

             
              <div className="form-section">
                <h4>Candidate Documents</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>PAN Card (Upload)</label>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx"
                      onChange={(e) => {
                        const f = e.target.files?.[0] || null;
                        setOfferLetterForm((prev) => ({
                          ...prev,
                          panCardFile: f,
                          panCardName: f ? f.name : (prev.panCardName || ""),
                        }));
                      }}
                    />
                    {offerLetterForm.panCardName && (
                      <div className="doc-upload-note">
                        <strong>PAN:</strong> {offerLetterForm.panCardName}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Aadhaar Card (Upload)</label>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx"
                      onChange={(e) => {
                        const f = e.target.files?.[0] || null;
                        setOfferLetterForm((prev) => ({
                          ...prev,
                          aadhaarCardFile: f,
                          aadhaarCardName: f ? f.name : (prev.aadhaarCardName || ""),
                        }));
                      }}
                    />
                    {offerLetterForm.aadhaarCardName && (
                      <div className="doc-upload-note">
                        <strong>Aadhaar:</strong> {offerLetterForm.aadhaarCardName}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h4>Organization Details</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Business Unit<span className="required-asterisk">*</span></label>
                    <select
                            value={offerLetterForm.business_unit}
                            onChange={(e) => {

                              const bu =
                                e.target.value;

                              setOfferLetterForm(prev => ({

                                ...prev,

                                business_unit:
                                  bu,

                                division:
                                  "",

                                division_head_name:
                                  "",

                                division_head_email:
                                  "",

                              }));

                            }}
                          >
                            <option value="">
                              Select Business Unit
                            </option>

                            {headcountOptions.businessUnits.map(
                              (bu) => (
                                <option
                                  key={bu}
                                  value={bu}
                                >
                                  {bu}
                                </option>
                              )
                            )}

                          </select>
                          
                  </div>
                  
                  <div className="form-group">
                    <label>Division<span className="required-asterisk">*</span></label>
                    <select
                          value={offerLetterForm.division}
                          onChange={(e) => {

                            const division =
                              e.target.value;

                            const bu =
                              offerLetterForm.business_unit;

                            const key =
                              bu && division
                                ? `${bu}|${division}`
                                : null;

                            const divisionHead =
                              key
                                ? headcountOptions
                                    .divisionHeads?.[key]
                                : null;


                            setOfferLetterForm(prev => ({

                              ...prev,

                              division,

                              division_head_name:
                                divisionHead?.name || "",

                              division_head_email:
                                divisionHead?.email || "",

                            }));

                          }}
                        >
                          <option value="">
                            Select Division
                          </option>

                          {headcountOptions.divisions.map(
                            (div) => (
                              <option
                                key={div}
                                value={div}
                              >
                                {div}
                              </option>
                            )
                          )}

                        </select>
                  </div>
                  
                  <div className="form-group">
                    <label>Department<span className="required-asterisk">*</span></label>
                    <select value={offerLetterForm.department} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, department: e.target.value })}>
                      <option value="">Select Department</option>
                      {headcountOptions.departments.map((dept) => (
                        <option key={dept} value={dept}>{dept}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-section">
  <h4>Location & Work Details</h4>

  <div className="form-row">
    {/* Current Location */}
    <div className="form-group">
      <label>Current Location</label>
      <input
        type="text"
        placeholder="Current Location"
        value={offerLetterForm.current_location}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            current_location: e.target.value,
          })
        }
      />
    </div>

    {/* Current Company */}
    <div className="form-group">
      <label>Current Company</label>
      <input
        type="text"
        placeholder="Current Company"
        value={offerLetterForm.current_company}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            current_company: e.target.value,
          })
        }
      />
    </div>

    {/* Offered Location */}
    <div className="form-group">
      <label>Offered Location<span className="required-asterisk">*</span></label>
      <select
        value={offerLetterForm.location_offered}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            location_offered: e.target.value,
          })
        }
      >
        <option value="">Select Offered Location</option>
        <option value="Bangalore">Bangalore</option>
        <option value="Chennai">Chennai</option>
        <option value="Hyderabad">Hyderabad</option>
        <option value="Coimbatore">Coimbatore</option>
      </select>
    </div>

    {/* Offered Company */}
    <div className="form-group">
      <label>Offered Company<span className="required-asterisk">*</span></label>
      <select
        value={offerLetterForm.offered_company}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            offered_company: e.target.value,
          })
        }
      >
<option value="">Select Offered Company</option>
          <option value="Univision Systems And Solutions Private Limited">
            Univision Systems And Solutions Private Limited
          </option>
          <option value="Eldaas Technologies Private Limited">
            Eldaas Technologies Private Limited
          </option>
        </select>
    </div>

    {/* Work Mode */}
    <div className="form-group">
      <label>Work Mode<span className="required-asterisk">*</span></label>
      <select
        value={offerLetterForm.work_mode}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            work_mode: e.target.value,
          })
        }
      >
        <option value="">Select</option>
        <option value="Work from Office">Work from Office</option>
        <option value="Remote">Remote</option>
        <option value="Hybrid">Hybrid</option>
      </select>
    </div>
  </div>

  <div className="form-row">
    <div className="form-group">
      <label>Expected DOJ<span className="required-asterisk">*</span></label>
      <input
        type="date"
        min={todayISODate()}
        value={offerLetterForm.expected_doj}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            expected_doj: e.target.value,
          })
        }
      />
    </div>

    {/* <div className="form-group">
      <label>Possible Revenue Start Date</label>
      <input
        type="date"
        value={offerLetterForm.possible_revenue_start_date}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            possible_revenue_start_date: e.target.value,
          })
        }
      />
    </div> */}

    {/* <div className="form-group">
      <label>Bill Rate / Month</label>
      <input
        type="text"
        placeholder="Bill Rate"
        value={offerLetterForm.bill_rate_per_month}
        onChange={(e) =>
          setOfferLetterForm({
            ...offerLetterForm,
            bill_rate_per_month: e.target.value,
          })
        }
      />
    </div> */}
  </div>
</div>

              {/* <div className="form-section">
                <h4>Additional Information</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Reporting Manager</label>
                    <input placeholder="Reporting Manager" value={offerLetterForm.reporting_manager} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, reporting_manager: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Customer Mapping</label>
                    <input placeholder="Customer" value={offerLetterForm.customer_mapping} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, customer_mapping: e.target.value })} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Service Agreement</label>
                    <textarea rows="2" placeholder="Service agreement details" value={offerLetterForm.service_agreement} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, service_agreement: e.target.value })} />
                  </div>
                </div>
              </div> */}


              <div className="form-group">
                    <label>Offer Type</label>

                    <select
                        value={offerLetterForm.offer_type}
                        onChange={(e)=>
                            setOfferLetterForm({
                                ...offerLetterForm,
                                offer_type:e.target.value
                            })
                        }
                    >

                        <option value="regular">
                            Regular Offer
                        </option>

                        <option value="conditional">
                            Conditional Offer
                        </option>

                    </select>
                </div>

                {/* ===========================================
                            REGULAR OFFER
                    =========================================== */}

                    {offerLetterForm.offer_type === "regular" && (

                    <div className="form-section">

                    <h3>Regular Offer Details</h3>

                    <hr/>

                    <h4>Compensation</h4>

                    <div className="form-row">

                    <div className="form-group">
                    <label>Current Fixed Salary</label>

                    <input
                    type="number"
                    value={offerLetterForm.current_ctc_fixed}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    current_ctc_fixed:e.target.value
                    })}
                    />

                    </div>

                    <div className="form-group">

                    <label>Expected Fixed Salary</label>

                    <input
                    type="number"
                    value={offerLetterForm.expected_ctc_fixed}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    expected_ctc_fixed:e.target.value
                    })}
                    />

                    </div>

                    <div className="form-group">

                    <label>Offered Fixed Salary<span className="required-asterisk">*</span></label>

                    <input
                    type="number"
                    value={offerLetterForm.offered_ctc_fixed}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    offered_ctc_fixed:e.target.value
                    })}
                    />

                    </div>

                    </div>

                    <div className="form-row">

                    <div className="form-group">

                    <label>Current Variable Type</label>

                    <select
                    value={offerLetterForm.current_ctc_variable}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    current_ctc_variable:e.target.value
                    })}
                    >

                    <option value="">Select</option>
                    <option>Monthly Bonus</option>
                    <option>Quarterly Bonus</option>
                    <option>Half Yearly Bonus</option>
                    <option>Yearly Bonus</option>

                    </select>

                    </div>

                    <div className="form-group">

                    <label>Expected Variable Type</label>

                    <select
                    value={offerLetterForm.expected_ctc_variable}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    expected_ctc_variable:e.target.value
                    })}
                    >

                    <option value="">Select</option>
                    <option>Monthly Bonus</option>
                    <option>Quarterly Bonus</option>
                    <option>Half Yearly Bonus</option>
                    <option>Yearly Bonus</option>

                    </select>

                    </div>

                    <div className="form-group">

                    <label>Offered Variable Type<span className="required-asterisk">*</span></label>

                    <select
                    value={offerLetterForm.offered_ctc_variable}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    offered_ctc_variable:e.target.value
                    })}
                    >

                    <option value="">Select</option>
                    <option>Monthly Bonus</option>
                    <option>Quarterly Bonus</option>
                    <option>Half Yearly Bonus</option>
                    <option>Yearly Bonus</option>

                    </select>

                    </div>

                    </div>

                    <div className="form-row">

                    <div className="form-group">

                    <label>Current Variable Amount</label>

                    <input
                    type="number"
                    value={offerLetterForm.current_ctc_variable_amount}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    current_ctc_variable_amount:e.target.value
                    })}
                    />

                    </div>

                    <div className="form-group">

                    <label>Expected Variable Amount</label>

                    <input
                    type="number"
                    value={offerLetterForm.expected_ctc_variable_amount}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    expected_ctc_variable_amount:e.target.value
                    })}
                    />

                    </div>

                    <div className="form-group">

                    <label>Offered Variable Amount<span className="required-asterisk">*</span></label>

                    <input
                    type="number"
                    value={offerLetterForm.offered_ctc_variable_amount}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    offered_ctc_variable_amount:e.target.value
                    })}
                    />

                    {/* <small className="form-hint">
                      The amount paid per period - the annual figure is
                      derived from it.
                    </small> */}

                    </div>

                    </div>

                    <div className="form-row">

                    <div className="form-group">

                    <label>Current Annual CTC</label>

                    <input
                      readOnly
                      value={getAnnualCTC(

                      offerLetterForm.current_ctc_fixed,

                      offerLetterForm.current_ctc_variable,

                      offerLetterForm.current_ctc_variable_amount

                      ).toLocaleString("en-IN")}
                      />

                    </div>

                    <div className="form-group">

                    <label>Expected Annual CTC</label>

                    <input
                          readOnly
                          value={getAnnualCTC(

                          offerLetterForm.expected_ctc_fixed,

                          offerLetterForm.expected_ctc_variable,

                          offerLetterForm.expected_ctc_variable_amount

                          ).toLocaleString("en-IN")}
                          />

                    </div>

                    <div className="form-group">

                    <label>Offered Annual CTC (incl. benefits)</label>

                   <input
                      readOnly
                      value={computeOfferCtcTotals({
                        fixedCtc: offerLetterForm.offered_ctc_fixed,
                        variableType: offerLetterForm.offered_ctc_variable,
                        variableAmount: offerLetterForm.offered_ctc_variable_amount,
                        annualVariablePay:
                          offerLetterForm.variable_annual_pay_amount,
                        annualRetentionBonus:
                          offerLetterForm.variable_retention_bonus_amount,
                      })
                        .total.toLocaleString("en-IN")}
                      />

                    </div>

                    </div>

                     <div className="form-row">

                    <div className="form-group">

                    <label>Annual Variable Pay (p.a.)</label>

                    <input
                    type="number"
                    value={offerLetterForm.variable_annual_pay_amount}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    variable_annual_pay_amount:e.target.value
                    })}
                    />

                    </div>

                    <div className="form-group">

                    <label>Annual Retention Bonus (p.a.)</label>

                    <input
                    type="number"
                    value={offerLetterForm.variable_retention_bonus_amount}
                    onChange={(e)=>setOfferLetterForm({
                    ...offerLetterForm,
                    variable_retention_bonus_amount:e.target.value
                    })}
                    />

                    </div>

                    </div>
                      <hr />

                <h4>Joining Bonus</h4>

                <div className="form-row">

                    <div className="form-group">
                        <label>Joining Bonus</label>

                        <select
                            value={offerLetterForm.joining_bonus}
                            onChange={(e)=>
                                setOfferLetterForm({
                                    ...offerLetterForm,
                                    joining_bonus:e.target.value
                                })
                            }
                        >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>

                    </div>

                    {offerLetterForm.joining_bonus==="Yes" && (

                    <div className="form-group">

                        <label>Joining Bonus Amount</label>

                        <input
                            type="number"
                            value={offerLetterForm.joining_bonus_amount}
                            onChange={(e)=>
                                setOfferLetterForm({
                                    ...offerLetterForm,
                                    joining_bonus_amount:e.target.value
                                })
                            }
                        />

                    </div>

                    )}

                </div>

                <p className="offer-note">
             Payable in second salary cycle after joining date.
                100% recovery if employee is not in active service for 12 months after payment date.
                </p>


                <h4>Retention Bonus</h4>

                <div className="form-row">

                <div className="form-group">

                <label>Retention Bonus</label>

                <select
                value={offerLetterForm.retention_bonus}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_bonus:e.target.value
                })
                }
                >

                <option value="No">No</option>
                <option value="Yes">Yes</option>

                </select>

                </div>

                {offerLetterForm.retention_bonus==="Yes" && (

                <div className="form-group">

                <label>Total Amount</label>

                <input
                type="number"
                value={offerLetterForm.retention_total}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_total:e.target.value
                })
                }
                />

                </div>

                )}

                </div>

                {offerLetterForm.retention_bonus==="Yes" && (

                <>

                <h4>Retention Installments</h4>

                <div className="form-row">

                <div className="form-group">

                <label>Installment 1 Date</label>

                <input
                type="date"
                min={retentionInstallmentMin(0, offerLetterForm)}
                value={offerLetterForm.retention_installment1_date}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment1_date:e.target.value
                })
                }
                />

                </div>

                <div className="form-group">

                <label>Amount</label>

                <input
                type="number"
                value={offerLetterForm.retention_installment1_amount}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment1_amount:e.target.value
                })
                }
                />

                </div>

                </div>

                <div className="form-row">

                <div className="form-group">

                <label>Installment 2 Date</label>

                <input
                type="date"
                min={retentionInstallmentMin(1, offerLetterForm)}
                value={offerLetterForm.retention_installment2_date}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment2_date:e.target.value
                })
                }
                />

                </div>

                <div className="form-group">

                <label>Amount</label>

                <input
                type="number"
                value={offerLetterForm.retention_installment2_amount}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment2_amount:e.target.value
                })
                }
                />

                </div>

                </div>

                <div className="form-row">

                <div className="form-group">

                <label>Installment 3 Date</label>

                <input
                type="date"
                min={retentionInstallmentMin(2, offerLetterForm)}
                value={offerLetterForm.retention_installment3_date}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment3_date:e.target.value
                })
                }
                />

                </div>

                <div className="form-group">

                <label>Amount</label>

                <input
                type="number"
                value={offerLetterForm.retention_installment3_amount}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                retention_installment3_amount:e.target.value
                })
                }
                />

                </div>

                </div>

                </>

                )}

                <hr />

                <h4>Grade & Designation</h4>

                <div className="form-row">

                {/* <div className="form-group">

                <label>Grade</label>

                <select
                value={offerLetterForm.grade}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                grade:e.target.value
                })
                }
                >

                <option value="">Select</option>

                <option value="A">A</option>

                <option value="B">B</option>

                <option value="C">C</option>

                </select>

                </div> */}

                <div className="form-group">

                <label>Designation / Title</label>

                <input
                list="designationList"
                value={offerLetterForm.designation}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                designation:e.target.value
                })
                }
                />

                <datalist id="designationList">

                <option value={offerLetterForm.position_offered}/>

                <option value="Software Engineer"/>

                <option value="Senior Software Engineer"/>

                <option value="QA Engineer"/>

                <option value="Business Analyst"/>

                <option value="HR Executive"/>

                </datalist>

                </div>

                </div>


                    </div>
                    )}

               {/* ===========================================
                        CONDITIONAL OFFER
                =========================================== */}

                {offerLetterForm.offer_type === "conditional" && (

                <div className="form-section">

                <h3>Conditional Offer Details</h3>

                <hr/>

                <h4>Training Agreement</h4>

                <div className="form-row">

                <div className="form-group">
                <label>Training Agreement Period<span className="required-asterisk">*</span></label>

                <select
                value={offerLetterForm.training_period}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                training_period:e.target.value
                })
                }
                >

                <option value="">Select</option>
                <option value="3 Years">3 Years</option>
                <option value="3 Years 6 Months">3 Years 6 Months</option>
                <option value="4 Years">4 Years</option>
                <option value="4 Years 6 Months">4 Years 6 Months</option>

                </select>

                </div>

                <div className="form-group">

                <label>Training Agreement Amount</label>

                <input
                type="number"
                placeholder="Amount"
                value={offerLetterForm.training_amount}
                readOnly
                className="readonly-input"
                />

                </div>

                </div>

                <hr/>

                <h4>Internship Details</h4>

                <div className="form-row">

                <div className="form-group">

                <label>Internship Training Period<span className="required-asterisk">*</span></label>

                <input
                type="text"
                placeholder="Auto / Manual"
                value={offerLetterForm.internship_period}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                internship_period:e.target.value
                })
                }
                />

                </div>

                <div className="form-group">

                <label>Internship Stipend / Month</label>

                <input
                type="number"
                placeholder="Monthly Stipend"
                value={offerLetterForm.internship_stipend}
                readOnly
                className="readonly-input"
                />
               

                </div>

                </div>

                <hr/>

                <h4>Compensation After Internship</h4>

                <table className="offer-table">

                <thead>

                <tr>

                <th scope="col">Year</th>

                <th scope="col">Fixed Salary</th>

                <th scope="col">Variable Type</th>

                <th scope="col">Variable Amount</th>

                <th scope="col">Annual CTC</th>

                </tr>

                </thead>

                <tbody>

                <tr>

                <td>Year 1</td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year1_fixed}
                readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <select
                value={offerLetterForm.year1_variable_type}
                disabled
                className="readonly-input"
                >

                <option value="">Select</option>
                <option>Monthly Bonus</option>
                <option>Quarterly Bonus</option>
                <option>Half Yearly Bonus</option>
                <option>Yearly Bonus</option>

                </select>

                </td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year1_variable_amount}
                 readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <input
                readOnly
                value={offerLetterForm.year1_ctc}
                />

                </td>

                </tr>

                <tr>

                <td>Year 2</td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year2_fixed}
                readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <select
                value={offerLetterForm.year2_variable_type}
                disabled
                className="readonly-input"
                >

                <option value="">Select</option>
                <option>Monthly Bonus</option>
                <option>Quarterly Bonus</option>
                <option>Half Yearly Bonus</option>
                <option>Yearly Bonus</option>

                </select>

                </td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year2_variable_amount}
                readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <input
                readOnly
                value={offerLetterForm.year2_ctc}
                />

                </td>

                </tr>

                <tr>

                <td>Year 3</td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year3_fixed}
                readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <select
                value={offerLetterForm.year3_variable_type}
                disabled
                className="readonly-input"
                >

                <option value="">Select</option>
                <option>Monthly Bonus</option>
                <option>Quarterly Bonus</option>
                <option>Half Yearly Bonus</option>
                <option>Yearly Bonus</option>

                </select>

                </td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year3_variable_amount}
                 readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <input
                readOnly
                value={offerLetterForm.year3_ctc}
                />

                </td>

                </tr>

                <tr>

                <td>Year 4</td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year4_fixed}
                readOnly
                className="readonly-input"
                />

                </td>

                <td>

                <select
                value={offerLetterForm.year4_variable_type}
                disabled
                className="readonly-input"
                >

                <option value="">Select</option>
                <option>Monthly Bonus</option>
                <option>Quarterly Bonus</option>
                <option>Half Yearly Bonus</option>
                <option>Yearly Bonus</option>

                </select>

                </td>

                <td>

                <input
                type="number"
                value={offerLetterForm.year4_variable_amount}
                onChange={(e)=>
                setOfferLetterForm({
                ...offerLetterForm,
                year4_variable_amount:e.target.value
                })
                }
                />

                </td>

                <td>

                <input
                readOnly
                value={offerLetterForm.year4_ctc}
                />

                </td>

                </tr>

                </tbody>

                </table>

                </div>

                )}    

              <div className="form-section">
                <h4>Additional Attachments (optional)</h4>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="file"
                      multiple
                      onChange={(e) => setAdditionalFiles(Array.from(e.target.files))}
                    />
                    {additionalFiles.length > 0 && (
                      <ul className="attachments-list">
                        {additionalFiles.map((f, i) => (
                          <li key={i}>{f.name}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="form-section">
                <h4>Approval Workflow</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Stage 1 Approver</label>
                    <select value={offerLetterForm.stage1Email} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, stage1Email: e.target.value })}>
                      <option value="">Select Stage 1 Approver</option>
                      {getApproverOptions("Stage1").map((entry, idx) => (
                        <option key={`s1-${idx}`} value={entry.email}>{entry.name ? `${entry.name} - ${entry.email}` : entry.email}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Stage 2 Approver</label>
                    <select value={offerLetterForm.stage2Email} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, stage2Email: e.target.value })}>
                      <option value="">Select Stage 2 Approver</option>
                      {getApproverOptions("Stage2").map((entry, idx) => (
                        <option key={`s2-${idx}`} value={entry.email}>{entry.name ? `${entry.name} - ${entry.email}` : entry.email}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Stage 3 Approver</label>
                    <select value={offerLetterForm.stage3Email} onChange={(e) => setOfferLetterForm({ ...offerLetterForm, stage3Email: e.target.value })}>
                      <option value="">Select Stage 3 Approver</option>
                      {getApproverOptions("Stage3").map((entry, idx) => (
                        <option key={`s3-${idx}`} value={entry.email}>{entry.name ? `${entry.name} - ${entry.email}` : entry.email}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div> */}

              <div className="modal-actions">
                {editingDraftId ? (
                  /* Resuming a draft: two ways out — keep saving it as a
                     draft so it can be resumed again, or push it into the
                     approval flow now that it is complete. */
                  <>
                    <LoadingButton
                      type="button"
                      className="primary-btn"
                      loading={submittingOffer && !savingDraft}
                      loadingText="Sending..."
                      onClick={(e) => handleCreateOffer(e, false)}
                      disabled={savingDraft}
                    >
                      Send for Approval
                    </LoadingButton>
                    <LoadingButton
                      type="button"
                      className="secondary-btn"
                      loading={savingDraft}
                      loadingText="Saving..."
                      onClick={(e) => handleCreateOffer(e, true)}
                      disabled={submittingOffer && !savingDraft}
                    >
                      Save Draft
                    </LoadingButton>
                  </>
                ) : (
                  <LoadingButton
                    type="submit"
                    className="primary-btn"
                    loading={submittingOffer && !savingDraft}
                    loadingText="Sending..."
                    disabled={savingDraft}
                  >
                    {editingOfferId
                      ? "Save Changes"
                      : "Create & Send for Approval"}
                  </LoadingButton>
                )}
                {/* Only meaningful while creating: editing an existing offer
                    already updates it in place. */}
                {!editingOfferId && (
                  <LoadingButton
                    type="button"
                    className="secondary-btn"
                    loading={savingDraft}
                    loadingText="Saving..."
                    onClick={(e) => handleCreateOffer(e, true)}
                    disabled={submittingOffer && !savingDraft}
                  >
                    Save as Draft
                  </LoadingButton>
                )}
                {/* <LoadingButton
                  type="button" className="secondary-btn" loading={generatingPreview} loadingText="Generating..."
                  onClick={handlePreview}
                >
                  Preview
                </LoadingButton> */}
                <button type="button" className="secondary-btn" onClick={() => { setShowCreateOfferModal(false); setEditingOfferId(null); setEditingDraftId(null); }} disabled={submittingOffer}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* =========================================================
    EDIT OFFER MODAL
========================================================= */}

{showEditOfferModal && editingOfferId && editingOffer && (
  <>
    {/* The editor reads offer_status from the `offer` prop below to decide
        whether a draft may edit every field and offer Save & Submit. */}
    {getOfferEditRole(editingOffer) === "recruiter" && (
      <RecruiterOfferEditor
  form={offerLetterForm}
  setForm={setOfferLetterForm}

  offer={editingOffer}

  onSave={saveStageEditor}

  onSaveAndSend={
    saveAndResubmitReturnedOffer
  }

  onCancel={closeEditOfferModal}

  saving={editOfferSaving}

  headcountOptions={headcountOptions}

  rejectionBanner={renderEditRejectionBanner()}

  role="recruiter"

  editableFields={
    EDITABLE_FIELDS.recruiter
  }

  isReturnedOffer={
    isReturnedOffer(editingOffer)
  }
/>
    )}


    {getOfferEditRole(editingOffer) === "hiring_manager" && (
      <HiringManagerOfferEditor
  form={offerLetterForm}
  setForm={setOfferLetterForm}

  onSave={saveStageEditor}

  onSaveAndSend={
    saveAndResubmitReturnedOffer
  }

  onCancel={closeEditOfferModal}

  saving={editOfferSaving}

  headcountOptions={headcountOptions}

  rejectionBanner={renderEditRejectionBanner()}

  editableFields={
    EDITABLE_FIELDS.hiring_manager
  }

  role="hiring_manager"

  isReturnedOffer={
    isReturnedOffer(editingOffer)
  }
/>
    )}


    {getOfferEditRole(editingOffer) === "bu_head" && (
     <BUHeadOfferEditor
  form={offerLetterForm}
  setForm={setOfferLetterForm}

  onSave={saveStageEditor}

  onSaveAndSend={
    saveAndResubmitReturnedOffer
  }

  onCancel={closeEditOfferModal}

  saving={editOfferSaving}

  headcountOptions={headcountOptions}

  rejectionBanner={renderEditRejectionBanner()}

  editableFields={
    EDITABLE_FIELDS.bu_head
  }

  role="bu_head"

  isReturnedOffer={
    isReturnedOffer(editingOffer)
  }
/>
    )}



    {getOfferEditRole(editingOffer) === "hr" && (
      <HROfferEditor
        form={offerLetterForm}
        setForm={setOfferLetterForm}
        onSave={saveStageEditor}
        onCancel={closeEditOfferModal}
        saving={editOfferSaving}
        headcountOptions={headcountOptions}
        rejectionBanner={renderEditRejectionBanner()}
        editableFields={EDITABLE_FIELDS.hr}
        role="hr"
      />
    )}
  </>
)}

      {/* ================= OFFER LETTER PREVIEW MODAL ================= */}
      {showOfferPreviewModal && (
        <div className="modal-overlay">
          <div className="modal-content offer-preview-modal">
            <h3>Offer Letter Preview</h3>
            <div
              id="offer-preview-content"
              className="offer-preview-content"
              dangerouslySetInnerHTML={{ __html: offerPreviewHtml }}
            />
            <div className="modal-actions">
              <LoadingButton type="button" className="primary-btn" onClick={handleDownloadOfferPdf} loading={downloadingPdf} loadingText="Downloading...">
                Download PDF
              </LoadingButton>
              {hrReleaseOffer ? (
                <LoadingButton
                  type="button"
                  className="primary-btn approve-send-btn"
                  onClick={handleReleaseGeneratedOffer}
                  loading={releasingGeneratedOffer}
                  loadingText="Releasing..."
                  disabled={downloadingPdf}
                >
                  Release to Candidate
                </LoadingButton>
              ) : (
                <LoadingButton
                  type="button"
                  className="primary-btn approve-send-btn"
                  onClick={handleApproveAndSend}
                  loading={approvingAndSending}
                  loadingText="Preparing..."
                  disabled={downloadingPdf}
                >
                  Approve & Send
                </LoadingButton>
              )}

              <button
                type="button"
                className="secondary-btn"
                onClick={() => {
                  setShowOfferPreviewModal(false);
                  setAdditionalFiles([]);
                  setHrReleaseOffer(null);
                }}
                disabled={approvingAndSending || releasingGeneratedOffer}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= OFFER DETAILS MODAL ================= */}
      {showDetailsModal && selectedDetails && (
        <div className="modal-overlay">
          <div className="modal-content offer-details-modal">
            <h3>Offer Details</h3>
            <div className="offer-details-grid">
              <div className="detail-section">
                <h4>Candidate</h4>
                <div className="detail-row"><span className="detail-label">Name:</span><span>{selectedDetails.candidate_name || `${selectedDetails.custom_first_name || ""} ${selectedDetails.custom_last_name || ""}`}</span></div>
                <div className="detail-row"><span className="detail-label">Position:</span><span>{selectedDetails.position_offered || selectedDetails.position}</span></div>
                <div className="detail-row"><span className="detail-label">Experience:</span><span>{selectedDetails.experience || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Relevant Exp:</span><span>{selectedDetails.relevant_experience || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Grade:</span><span>{selectedDetails.grade || "-"}</span></div>
              </div>

                <div className="detail-section">
                <h4>Organization</h4>
                <div className="detail-row"><span className="detail-label">Business Unit:</span><span>{selectedDetails.business_unit || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Division:</span><span>{selectedDetails.division || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Department:</span><span>{selectedDetails.department || "-"}</span></div>
              </div>

              <div className="detail-section">
                <h4>Location & Work</h4>
                <div className="detail-row"><span className="detail-label">Current Location:</span><span>{selectedDetails.current_location || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Offered Location:</span><span>{selectedDetails.location_offered || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Work Mode:</span><span>{selectedDetails.work_mode || "-"}</span></div>
              </div>

              <div className="detail-section">
                <h4>Dates</h4>
                <div className="detail-row"><span className="detail-label">Expected DOJ:</span><span>{selectedDetails.expected_doj ? new Date(selectedDetails.expected_doj).toLocaleDateString() : "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Revenue Start:</span><span>{selectedDetails.possible_revenue_start_date ? new Date(selectedDetails.possible_revenue_start_date).toLocaleDateString() : "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Bill Rate/Month:</span><span>{selectedDetails.bill_rate_per_month ? `₹${selectedDetails.bill_rate_per_month}` : "-"}</span></div>
              </div>

              {/* Compensation - section E and F of Annexure-A. The variable
                  block only appears when a variable pay was explicitly
                  entered for this offer. */}
              {(() => {
                const ctc = getOfferCompensationSummary(selectedDetails);

                if (!ctc.hasCompensation) {
                  return null;
                }

                return (
                  <div className="detail-section">
                    <h4>Compensation</h4>
                    <div className="detail-row"><span className="detail-label">Fixed CTC:</span><span>{formatInr(ctc.fixed)}</span></div>
                    <div className="detail-row"><span className="detail-label">Total Fixed (E):</span><span>{formatInr(ctc.fixedTotal)}</span></div>

                    {ctc.hasVariable && (
                      <>
                        <div className="detail-row"><span className="detail-label">Variable Type:</span><span>{ctc.variableType || "-"}</span></div>
                        <div className="detail-row"><span className="detail-label">Variable Amount:</span><span>{formatInr(ctc.variableAmount)}{ctc.variableAmount > 0 ? ` per ${ctc.variablePeriodLabel.toLowerCase()}` : ""}</span></div>
                        <div className="detail-row"><span className="detail-label">Variable (Annual):</span><span>{formatInr(ctc.variableAmountAnnual)}</span></div>

                        {ctc.annualVariablePay > 0 && (
                          <div className="detail-row"><span className="detail-label">Annual Variable Pay:</span><span>{formatInr(ctc.annualVariablePay)}</span></div>
                        )}

                        {ctc.retentionBonus > 0 && (
                          <div className="detail-row"><span className="detail-label">Annual Retention Bonus:</span><span>{formatInr(ctc.retentionBonus)}</span></div>
                        )}

                        <div className="detail-row"><span className="detail-label">Total Variable (F):</span><span>{formatInr(ctc.variableTotal)}</span></div>
                      </>
                    )}

                    <div className="detail-row detail-row-total"><span className="detail-label">Total CTC (E+F):</span><span>{formatInr(ctc.total)}</span></div>
                  </div>
                );
              })()}

              {/* <div className="detail-section">
                <h4>Additional</h4>
                <div className="detail-row"><span className="detail-label">Reporting Manager:</span><span>{selectedDetails.reporting_manager || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Customer Mapping:</span><span>{selectedDetails.customer_mapping || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Service Agreement:</span><span>{selectedDetails.service_agreement || "-"}</span></div>
              </div> */}

              <div className="detail-section">
                <h4>Workflow</h4>
                <div className="detail-row"><span className="detail-label">Status:</span><span>{renderStatusBadge(selectedDetails.offer_status)}</span></div>
                <div className="detail-row"><span className="detail-label">Created By:</span><span>{selectedDetails.created_by_name || selectedDetails.created_by || "-"}</span></div>
                <div className="detail-row"><span className="detail-label">Created At:</span><span>{selectedDetails.created_at ? new Date(selectedDetails.created_at).toLocaleString() : "-"}</span></div>
                <div className="detail-row"><span className="detail-label">HR Released:</span><span>{selectedDetails.hr_released_by ? `${selectedDetails.hr_released_by} at ${selectedDetails.hr_released_at ? new Date(selectedDetails.hr_released_at).toLocaleString() : ""}` : "Not yet"}</span></div>
              </div>

              {getLatestRejectionRemark(selectedDetails) && (
                <div className="detail-section rejection-history-section">
                  <h4>Latest Rejection</h4>

                  <div className="detail-row">
                    <span className="detail-label">Rejected By:</span>
                    <span>
                      {getLatestRejectionRemark(selectedDetails)?.by_name ||
                        getLatestRejectionRemark(selectedDetails)?.by ||
                        "-"}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Reason:</span>
                    <span>
                      {(() => {
                        const rejReason =
                          getLatestRejectionRemark(selectedDetails)?.reason ||
                          getLatestRejectionRemark(selectedDetails)?.remarks;
                        return rejReason
                          ? rejReason.trim()
                          : "nothing mentioned";
                      })()}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Returned To:</span>
                    <span>
                      {getLatestRejectionRemark(selectedDetails)?.returned_to ||
                        "-"}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Date:</span>
                    <span>
                      {getLatestRejectionRemark(selectedDetails)?.at
                        ? new Date(
                            getLatestRejectionRemark(selectedDetails).at
                          ).toLocaleString()
                        : "-"}
                    </span>
                  </div>
                </div>
              )}

              <div className="detail-section">
                <h4>Stage Approvers</h4>
                <div className="detail-row"><span className="detail-label">Stage 1:</span><span>{selectedDetails.stage1_email ? `${selectedDetails.stage1_email} ${selectedDetails.stage1_status ? `(${selectedDetails.stage1_status})` : ""}` : "Not assigned"}</span></div>
                <div className="detail-row"><span className="detail-label">Stage 2:</span><span>{selectedDetails.stage2_email ? `${selectedDetails.stage2_email} ${selectedDetails.stage2_status ? `(${selectedDetails.stage2_status})` : ""}` : "Not assigned"}</span></div>
                <div className="detail-row"><span className="detail-label">Stage 3:</span><span>{selectedDetails.stage3_email ? `${selectedDetails.stage3_email} ${selectedDetails.stage3_status ? `(${selectedDetails.stage3_status})` : ""}` : "Not assigned"}</span></div>
              </div>
            </div>

            {/* Approval History */}
            {selectedDetails.approval_history && selectedDetails.approval_history.length > 0 && (
              <div className="detail-section">
                <h4>Approval History</h4>
                <table className="approval-history-table">
                  <thead>
                    <tr>
                      <th scope="col">Stage</th>
                      <th scope="col">Action</th>
                      <th scope="col">By</th>
                      <th scope="col">Date</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(typeof selectedDetails.approval_history === 'string' ? JSON.parse(selectedDetails.approval_history) : selectedDetails.approval_history).map((entry, idx) => (
                      <tr key={idx}>
                        <td>{entry.stage === "HR" ? "HR Release" : `Stage ${entry.stage}`}</td>
                        <td>{entry.action}</td>
                        <td>{entry.by_name || entry.by}</td>
                        <td>{entry.at ? new Date(entry.at).toLocaleString() : ""}</td>
                        <td>{entry.remarks || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className="modal-actions">
              {canEditOffer(selectedDetails) && (
                <button
                  className="edit-btn"
                  onClick={() => {
                    setShowDetailsModal(false);
                    openEditOfferModal(selectedDetails.id || selectedDetails.offer_id);
                  }}
                >
                  Edit
                </button>
              )}
              <button className="secondary-btn" onClick={() => setShowDetailsModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ================= STAGE 1/2/3 DELEGATE MODAL ================= */}
      {showDelegateModal && delegateOffer && (
        <DelegateModal
          stage={delegateStage}
          offer={delegateOffer}
          onClose={() => {
            setShowDelegateModal(false);
            setDelegateOffer(null);
            setDelegateStage(null);
          }}
          onDelegated={() => fetchOffers()}
        />
      )}

      {/* ================= HR OFFER RELEASE CHECKLIST ================= */}
      {showReleaseChecklist && releaseChecklistOffer && (
        <OfferReleaseChecklistModal
          offer={releaseChecklistOffer}
          open={showReleaseChecklist}
          onClose={() => {
            if (generatingPreview) return;
            setShowReleaseChecklist(false);
            setReleaseChecklistOffer(null);
          }}
          onGenerate={handleGenerateReleaseOffer}
        />
      )}

      {showRejectModal && (
  <div
    className="reject-modal-overlay"
    onMouseDown={(event) => {
      if (
        event.target ===
        event.currentTarget
      ) {
        handleCloseRejectModal();
      }
    }}
  >

    <div className="reject-modal">

      <div className="reject-modal-header">

        <div>
          <h2>
            Reject Offer
          </h2>

          <p>
            The offer will be returned
            to the person who sent it
            to you.
          </p>
        </div>

        <button
          type="button"
          className="reject-modal-close"
          onClick={
            handleCloseRejectModal
          }
          disabled={rejecting}
        >
          ×
        </button>

      </div>

      <div className="reject-modal-body">

        {rejectingOffer && (
          <div className="reject-offer-info">

            <strong>
              Candidate
            </strong>

            <span>
              {rejectingOffer.candidate_name ||
               `${rejectingOffer.custom_first_name || ""}
               ${rejectingOffer.custom_last_name || ""}`.trim() ||
               "-"}
            </span>

          </div>
        )}

        <div className="reject-field">

          <label>
            Rejection Reason
            <span>*</span>
          </label>

          <textarea
            value={rejectionReason}
            onChange={(event) =>
              setRejectionReason(
                event.target.value
              )
            }
            placeholder="Enter the reason for rejecting this offer..."
            rows={6}
            maxLength={2000}
            disabled={rejecting}
          />

          <small>
            {rejectionReason.length}/2000
          </small>

        </div>

      </div>

      <div className="reject-modal-footer">

        <button
          type="button"
          className="reject-cancel-button"
          onClick={
            handleCloseRejectModal
          }
          disabled={rejecting}
        >
          Cancel
        </button>

        <button
          type="button"
          className="reject-submit-button"
          onClick={
            handleRejectWorkflow
          }
          disabled={
            rejecting ||
            !rejectionReason.trim()
          }
        >
          {rejecting
            ? "Rejecting..."
            : "Reject & Return"}
        </button>

      </div>

    </div>

  </div>
)}

    <ConfirmModal
      isOpen={!!offerToDelete}
      variant="danger"
      title="Delete offer?"
      message="This offer will be permanently deleted. This cannot be undone."
      confirmLabel="Delete"
      cancelLabel="Cancel"
      isLoading={deletingOffer}
      loadingText="Deleting..."
      onConfirm={confirmRemoveOffer}
      onCancel={() => setOfferToDelete(null)}
    />
    <ConfirmModal
      isOpen={confirmReleaseGenerated}
      variant="info"
      title="Release offer?"
      message="Release this generated offer to the candidate?"
      confirmLabel="Release"
      cancelLabel="Cancel"
      isLoading={releasingGeneratedOffer}
      loadingText="Releasing..."
      onConfirm={doReleaseGeneratedOffer}
      onCancel={() => setConfirmReleaseGenerated(false)}
    />
    </div>
  );
}